import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
      brand: "Drivons",
      mk: {
        nav: { riders: "Riders", drivers: "Drivers", services: "Services", download: "Download", signin: "Sign in" },
        hero: {
          eyebrow: "Live in 6 languages",
          h1a: "Get anywhere.",
          h1b: "Get anything done.",
          sub: "Rides, deliveries, moving, roadside help — Drivons connects you to a nearby, vetted operator in seconds.",
          ctaGet: "Get the app",
          ctaDrivers: "Drive with us",
          stat1: "Languages", stat2: "Service types", stat3: "Support",
        },
        services: {
          eyebrow: "One app, endless needs",
          h2: "8 services, 1 tap away",
          sub: "From a quick ride to a mid-move breakdown — Drivons dispatches a nearby verified operator in seconds.",
        },
        riders: {
          eyebrow: "For riders",
          h3: "Book in seconds. Pay however you like.",
          p1: "Live map + upfront fare — no meter surprises.",
          p2: "Cash, PayPal, wallet, or card (via PayPal).",
          p3: "24/7 human support, in your language.",
          p4: "Rate & tip your driver from the trip receipt.",
          cta: "Try Drivons free",
        },
        drivers: {
          eyebrow: "FOR DRIVERS",
          h3: "Drive with us. Keep 85% of every ride.",
          p1: "Flat 15% platform fee. No hidden cuts.",
          p2: "Instant weekly payouts to your bank via PayPal.",
          p3: "Choose your own hours — accept or decline every request.",
          p4: "Reserved rides, broadcast dispatch, or nearby random — you pick.",
          cta: "Start earning",
        },
        features: {
          eyebrow: "Why Drivons",
          h2: "Fair pricing. Real drivers. No surprises.",
          feat1t: "Instant dispatch",
          feat1v: "Nearest operator gets pinged in under 3 seconds.",
          feat2t: "Real-time tracking",
          feat2v: "Follow your driver on the map from pickup to drop-off.",
          feat3t: "Verified operators",
          feat3v: "Every driver is licensed, insured and background-checked.",
          feat4t: "6 languages",
          feat4v: "English, Arabic, Hebrew, Russian, Turkish, French — with full RTL.",
        },
        dl: {
          eyebrow: "Get Drivons",
          h2a: "Your city.",
          h2b: "In one tap.",
          sub: "Available on iOS and Android. Free to download, no subscription.",
          note: "Store links go live when the app is approved. Meanwhile, sign up at drivon.co.il.",
          appleLine1: "Download on the",
          googleLine1: "Get it on",
        },
      },
      nav: {
        services: "Services",
        how: "How it Works",
        suppliers: "For Suppliers",
        signIn: "Sign In",
        getStarted: "Sign Up",
        dashboard: "Dashboard",
        logout: "Logout",
        home: "Home",
        activity: "Activity",
        account: "Account",
        about: "About",
        pricing: "Pricing",
        contact: "Contact",
        support: "Help & Support",
        changePassword: "Change password",
      },
      categories: {
        moving: "Moving & Relocation",
        moving_desc: "Full crews, trucks, packing.",
        transport: "Freight Transport",
        transport_desc: "Long-haul, LTL, refrigerated.",
        towing: "Towing",
        towing_desc: "24/7 flatbed & wheel-lift.",
        taxi: "Taxi",
        taxi_desc: "On-demand rides & fleet dispatch.",
        mechanic: "Mobile Mechanic",
        mechanic_desc: "ASE-certified, comes to you.",
        tire: "Tire Repair",
        tire_desc: "Roadside patch, plug & change.",
        delivery: "Delivery",
        carwash: "Car Wash",
        serviceOptions: {
          carwash: {
            exterior: "Exterior Wash",
            exterior_interior: "Exterior + Interior",
            premium: "Premium Wash",
          },
          delivery: {
            motorcycle: "Motorcycle",
            car: "Car",
          },
          moving: {
            small_van:          "Small Van",
            medium_truck:       "Medium Truck",
            large_truck:        "Large Truck",
            xl_truck:           "Heavy Truck",
            refrigerated_van:   "Refrigerated Van",
            refrigerated_truck: "Refrigerated Truck",
          },
          moving_desc: {
            small_van:          "Up to ~1t · 4m³ — small items, small business",
            medium_truck:       "Up to ~3.5t · 15m³ — 2-3 room apartments",
            large_truck:        "Up to ~7.5t · 35m³ — 4+ room apartments, commercial",
            xl_truck:           "12t+ · 60m³+ — heavy commercial cargo",
            refrigerated_van:   "❄ Up to ~1t · 4m³ · 2-8°C — food, restaurants",
            refrigerated_truck: "❄ Up to ~3.5t · 15m³ · 2-8°C — supermarkets, suppliers",
          },
        },
        bus: "Bus Trip",
        bus_desc: "Charter minibus (12–15 seats) or full coach (30–50 seats).",
        luxury: "Luxury",
        luxury_desc: "Sedan, SUV, limousine, supercar — with or without a chauffeur.",
        crane: "Crane Transport",
        crane_desc: "12–42m+ boom heights — mobile cranes for every lift.",
        limousine: "Limousine",
        delivery_desc: "Same-day parcels, food & groceries.",
      },
      landing: {
        hello: "Welcome",
        helloBack: "Welcome back",
        popular: "Popular",
        popularBadge: "Popular",
        popularSub: "most requested near you",
        searchPlaceholder: "Search services, taxi, mechanic…",
        walletTitle: "PAY & GO",
        freeSignup: "Sign up free — pay only when you book",
        bannerEyebrow: "PROMO",
        bannerTitle: "Book faster. Save more.",
        bannerSubtitle: "Cash or card at checkout · 15% platform commission",
        explore: "Explore",
        promo1: "Fast dispatch",
        promo2: "Verified crews",
        promo3: "Refer & earn",
        featuredEyebrow: "TOP OPERATORS",
        featuredTitle: "Popular near you",
        seeAll: "See all",
        supplierEyebrow: "FOR DRIVERS",
        supplierTitleShort: "Own the trucks? Keep the margin.",
        supplierSub: "List free · Only 15% commission on completed jobs",
        becomeSupplier: "Start earning",
        currentLocation: "CURRENT LOCATION",
        location: "SET YOUR LOCATION",
        setLocation: "Tap to set your location",
        locationDenied: "Location access blocked. Enable it in your browser for nearby suppliers.",
        nearbyEyebrow: "NEAR YOU",
        nearbyTitle: "Available around you",
        sosEyebrow: "URGENT",
        sosTitle: "Flat tire? Need a tow?",
        sosDesc: "Fastest roadside help. Tap for nearest crew.",
        desktopH1a: "Help arrives at your side.",
        desktopH1b: "Order the nearest crew in seconds.",
        desktopSub: "Flat tire? Dead battery? Need a tow, a taxi, or a moving crew? Drivons dispatches the closest operator directly to your location — pay cash on arrival or by card.",
        desktopFeeLabel: "PLATFORM FEE",
        live: "Live · 12,400 crews on network",
        heroCtaOrder: "Send a request",
        heroCtaSupplier: "Drive with us",
        heroLine1: "Help,",
        heroLine2: "when you need it.",
        stats: { response: "AVG RESPONSE", fee: "REQUEST FEE", free: "FREE", operators: "OPERATORS", requests: "REQUESTS / MO" },
      },
      about: {
        eyebrow: "ABOUT US",
        title: "Built for when things break down.",
        sub: "Drivons connects drivers, homeowners, and businesses with the nearest available operator for moving, transport, towing, taxi, mobile mechanic, and tire repair — 24/7.",
        f1t: "Instant dispatch",
        f1d: "Request a service and the nearest verified operator is on their way in minutes.",
        f2t: "Right to your location",
        f2d: "GPS-based matching. No need to describe where you are — we know.",
        f3t: "Zero commitment",
        f3d: "Sign up free. Pay only when you book — cash on arrival or by card.",
        storyEyebrow: "OUR STORY",
        storyTitle: "The gig-economy playbook, applied to roadside help.",
        storyP1: "We started because getting help when your car dies on the highway shouldn't take 3 phone calls and 90 minutes. If Uber can find you a car in 4 minutes, why can't the same happen for a tow truck or a mobile mechanic?",
        storyP2: "Drivons is a direct-to-supplier marketplace: no middlemen, transparent pricing, and 15% platform commission on completed jobs. Operators own their customers and their margin.",
      },
      pricing: {
        eyebrow: "PRICING",
        title: "Straightforward. Fair. Transparent.",
        sub: "Customers pay nothing to sign up or browse. Suppliers list for free and keep 85% of every completed job.",
        free: "$0",
        perJob: "per completed job",
        customerEyebrow: "FOR CUSTOMERS",
        customerTitle: "Always free",
        customer1: "Free account · No card required",
        customer2: "Request any service, cancel anytime",
        customer3: "Pay cash on arrival or by card",
        customer4: "Real-time status & operator ratings",
        supplierEyebrow: "FOR DRIVERS",
        supplierTitle: "15% commission — that's it",
        supplier1: "List all your services free",
        supplier2: "Set your own prices, keep 85%",
        supplier3: "Instant notifications for new requests",
        supplier4: "Own your customers · No lead-gen fees",
        ctaSignUp: "Sign up as customer",
        ctaBecomeSupplier: "Start earning",
        footnote: "The 15% platform fee applies to completed and paid jobs only. Refunds and cancellations don't incur fees. Payment via PayPal (accepts card, Apple Pay & Google Pay), the in-app wallet, or cash on arrival.",
      },
      contact: {
        eyebrow: "CONTACT",
        title: "We're here when you need us.",
        sub: "Reach out for support, partnerships, or if you need help placing a request.",
        email: "EMAIL",
        phone: "24/7 DISPATCH",
        chat: "LIVE HELP",
        chatValue: "Chat inside the app",
        hoursEyebrow: "AVAILABILITY",
        hoursTitle: "Always on. Always dispatching.",
        hoursDesc: "Whether it's 3 AM on a Sunday or noon on a Monday, our dispatch is live and operators are on standby.",
        dispatchLabel: "DISPATCH",
      },
      auth: {
        signIn: "Sign In",
        signInSub: "Enter the dispatch",
        signInSubDriver: "Drive with us — start earning.",
        signInPassenger: "Sign in as Passenger",
        signInDriver: "Sign in as Driver",
        rolePassenger: "Passenger",
        roleDriver: "Driver",
        noDriverAccount: "New driver?",
        signUpDriver: "Sign up to drive",
        roleMismatchDriver: "This is a driver account — signing you in as a driver.",
        roleMismatchPassenger: "This is a passenger account — signing you in as a passenger.",
        createAccount: "Create Account",
        createSub: "Join the network",
        email: "Email",
        password: "Password",
        name: "Full Name",
        noAccount: "No account?",
        signUp: "Sign up",
        haveAccount: "Have an account?",
        iAmCustomer: "I'm a Customer",
        iAmSupplier: "I'm a Supplier",
        continueWithGoogle: "Continue with Google",
        or: "OR",
        welcome: "Welcome back",
        accountCreated: "Account created",
        freeSignupNote: "Free to sign up. No card required. You'll only pay when you book a service — cash on arrival or by card.",
      },
      services: {
        eyebrow: "// ALL SERVICES",
        title: "Nearest crew, on demand",
        categoryEyebrow: "//",
        operatorsAvailable: "operators available",
        loading: "Loading operators…",
        empty: "No operators nearby",
        emptyDesc: "Try widening your search or a different category.",
        all: "All",
        by: "BY",
        per: "PER",
        book: "Request",
        sortedNearest: "Sorted by nearest",
      },
      booking: {
        eyebrow: "// SERVICE REQUEST",
        title: "Where should we send help?",
        details: "DETAILS",
        route: "ROUTE",
        pickup: "PICKUP",
        pickupPlaceholder: "Your current location",
        dropoff: "DROP-OFF",
        dropoffPlaceholder: "Where to?",
        useMyLocation: "USE MY LOCATION",
        optional: "(opt.)",
        when: "WHEN",
        now: "Now",
        nowDesc: "ETA ~{{min}} min",
        later: "Schedule",
        laterDesc: "Pick a future date & time",
        pickDateTime: "Pick date & time",
        eta: "ETA",
        min: "min",
        quantity: "Quantity",
        scheduled: "Scheduled",
        notes: "Notes",
        notesPlaceholder: "Special instructions, floor number, gate code, etc.",
        summary: "REQUEST SUMMARY",
        refPrice: "Reference price",
        category: "Category",
        estimate: "Estimate",
        finalPrice: "Final price confirmed by supplier",
        sendRequest: "Send Request",
        freeAlert: "Free · Supplier notified instantly",
        requestSent: "Request sent — the supplier has been notified",
        pickupRequired: "Pickup address required",
        onlyCustomers: "Only customer accounts can request services",
      },
      dashboard: {
        myRequests: "My Requests",
        supplierHq: "Supplier HQ",
        adminConsole: "Admin Console",
        totalRequests: "TOTAL REQUESTS",
        active: "ACTIVE",
        completed: "COMPLETED",
        newRequests: "NEW REQUESTS",
        listings: "LISTINGS",
        users: "USERS",
        suppliers: "SUPPLIERS",
        requests: "REQUESTS",
        recent: "RECENT REQUESTS",
        incoming: "INCOMING REQUESTS",
        myListings: "MY LISTINGS",
        allRequests: "ALL REQUESTS",
        noRequests: "No requests yet",
        noListings: "Create your first listing →",
        browse: "Browse services →",
        newListing: "New",
        newListingTitle: "New Listing",
        listingCreated: "Listing created",
        verify: "Verify",
        markAllViewed: "Mark all viewed",
        newRequestsBanner: "new requests",
        newRequestsBannerSub: "Customers are waiting for your response.",
        accept: "Accept Request",
        decline: "Decline",
        startJob: "Start Job",
        markComplete: "Mark Complete",
        supplierLabel: "SUPPLIER",
        customerLabel: "CUSTOMER",
        newBadge: "NEW",
        netEarnings: "NET EARNINGS",
        platformFees: "PLATFORM FEES",
        upcoming: "UPCOMING",
        upcomingSection: "SCHEDULED FOR LATER",
        scheduled: "SCHEDULED",
        walletCta: "Open Wallet", quickReorder: "Quick Reorder", reorder: "Reorder", reorderSuccess: "Reorder placed!", listingUnavailable: "This service is no longer available.",
        navigate: "Navigate",
        stops: "Stops",
        addStop: "Add a stop",
        stopAdded: "Stop added",
        stopNeedsCoords: "Tap GPS to pin the stop location",
        dispatchNow: "Dispatch now",
        dispatchingNow: "Dispatching now — finding a driver…",
        cancel: "Cancel",
      },
      rating: {
        rateService: "Rate this service",
        title: "How was it?",
        subtitle: "Your rating helps other customers pick the best operators.",
        commentPlaceholder: "Optional: leave a comment for the operator…",
        submit: "Submit rating",
        thanks: "Thanks for your review!",
      },
      footer: {
        services: "Services",
        company: "Company",
        ops: "Ops",
        about: "About",
        careers: "Careers",
        contact: "Contact",
        status: "Status:",
        operational: "OPERATIONAL",
        dispatch: "24 / 7 Dispatch",
        tagline: "Industrial-grade services marketplace. Direct from the operators who move, haul, fix, and drive.",
        copyright: "© 2026 THE FAST SERVICE — BUILT FOR THE WORKING CREW",
      },
      payment: {
        method: "PAYMENT METHOD",
        total: "Total",
        platformFee: "Platform fee",
        supplierGets: "Supplier receives",
        feeNote: "Drivons takes a 15% commission on completed jobs. Suppliers receive 85% of the total.",
        cash: "Cash on Arrival",
        cashDesc: "Pay the operator directly on arrival.",
        card: "Card · Apple Pay · Google Pay",
        cardDesc: "Pay securely — Apple Pay, Google Pay, or any credit/debit card.",
        payNow: "Pay Now",
        payLater: "Send Request",
        confirmPayment: "Confirming payment…",
        paid: "Paid & Confirmed",
        paidDesc: "The supplier has been notified. Track status in your dashboard.",
        cancelled: "Cancelled",
        cancelledDesc: "Payment cancelled. Order was not placed.",
        failed: "Payment issue",
        failedDesc: "Try again or contact support.",
        markCashPaid: "Mark Cash Received",
        cashPaid: "CASH RECEIVED", walletPaid: "WALLET PAID", walletPending: "WALLET PENDING",
        cardPaid: "CARD PAID",
        awaitingCash: "AWAITING CASH",
        awaitingCard: "AWAITING PAYMENT",
        walletInsufficient: "Wallet balance is not enough for this trip.",
        receipt: {
          eyebrow: "Payment received",
          thanks: "Thanks — your driver is set.",
          tripSection: "Your trip",
          pickup: "Pickup",
          dropoff: "Drop-off",
          breakdownSection: "Fare breakdown",
          baseFare: "Base fare",
          distanceCharge: "Distance",
          timeCharge: "Time",
          surge: "Surge",
          total: "Total",
          txSection: "Transaction reference",
          captureId: "Capture ID",
          copy: "Copy",
          copied: "Copied",
          captureCopied: "Transaction ID copied",
          viewOrders: "View my orders",
          bookAnother: "Book another",
        },
        paypal: {
          confirming: "Confirming your PayPal payment…",
          failed: "Payment failed",
          retry: "Try again",
        },
      },
      request: {
        eyebrow: "ON-DEMAND",
        title: "Request a service",
        serviceType: "What do you need?",
        pickup: "Pickup location",
        pickupPh: "Where are you?",
        dropoff: "Where to?",
        dropoffPh: "Destination",
        optional: "optional",
        gps: "GPS",
        cta: "Request Now",
        note: "The nearest available drivers will be notified. First to accept becomes your driver.",
        farePreview: "Fare preview",
        setPickupFirst: "Set pickup to see fare estimate",
        fareUnavailable: "Pricing not available for this location yet.",
        flatFare: "flat rate",
        base: "Base",
        addDropoffForDistance: "Add a destination to see a distance-based estimate",
        looking: "Looking for a nearby driver…",
        noDrivers: "No drivers responded yet",
        driversAlerted: "drivers alerted",
        stillDeciding: "still deciding",
        allDeclined: "Every nearby driver has declined or ignored. Try broadcasting to more drivers or cancel and try later.",
        stillWaiting: "Still waiting for a driver to accept. You can wait, re-broadcast to nearby drivers, or cancel.",
        rebroadcast: "Re-notify nearby drivers",
        rebroadcasted: "Re-notified nearby drivers",
        cancel: "Cancel request",
        cancelled: "Request cancelled",
        driverFound: "Driver assigned!",
        completed: "Trip completed",
        viewInDashboard: "View in Dashboard",
        locationDenied: "Location permission denied",
        locDenied: "Location permission denied. Enable it in your device / browser settings, then tap again.",
        locUnavailable: "Your device could not get a GPS fix. Try again outdoors or enter your address manually.",
        locTimeout: "Location request timed out. Please try again.",
        locInsecure: "Geolocation requires HTTPS. Please reload over a secure connection.",
        locGeneric: "Could not get your location. Please enter your pickup address.",
        pickCategory: "Pick a service category",
        needPickup: "Set your pickup location",
        sent: "Request sent — looking for a driver…",
        pickTaxiClass: "Pick a taxi class",
        pickTruckBand: "Minimum truck capacity",
        anyCapacity: "Any",
        when: "When do you need it?",
        now: "Now",
        nowHint: "Dispatch immediately",
        later: "Schedule for later",
        laterHint: "Book a future time",
        pickDateTime: "Date & time",
        pickWhen: "Pick a date & time",
        pickFuture: "Pick a time at least 5 minutes from now",
        scheduleDispatchHint: "We'll start dispatching drivers ~10 min before your booking.",
        scheduled: "Scheduled — we'll dispatch a driver near your booking time",
        ctaSchedule: "Schedule Ride",
        noteScheduled: "We'll match a nearby driver ~10 min before your booking time.",
        stops: "Stops",
        addStop: "Add a stop",
        stopPh: "Stop address",
        stopsHint: "Add intermediate stops if you need the driver to make a quick pickup or drop along the way.",
        removeStop: "Remove stop",
        useMyLocation: "Use my location",
        back: "Back",
        driverNearby: "driver nearby",
        driversNearby: "drivers nearby",
        arrivesIn: "arrives in",
        minShort: "min",
        away: "away",
        reserve: "Reserve",
        ctaChoose: "Request",
        driverNotes: "Notes for the driver",
        driverNotesPh: "Anything the driver should know (gate code, meeting point, fragile items…)",
        luxuryStyle: "Body style",
        luxuryRailTitle: "Luxury cars near you",
        noLuxuryNearby: "No luxury cars available in your area yet — try widening the pickup area or check back soon.",
        luxuryVehicle: "Luxury vehicle",
      },
      luxury: {
        with_driver: "With driver",
        without_driver: "Self-drive",
        style_sedan: "Sedan",
        style_suv: "SUV",
        style_limousine: "Limousine",
        style_supercar: "Supercar",
        style_convertible: "Convertible",
        per_trip: "Per trip",
        hourly: "Hourly",
        daily: "Daily",
        hr: "hr",
        day: "day",
        hours: "Hours",
        days: "Days",
        chooseClass: "Choose a class",
        billing: "Billing",
        package_4h: "4h Package",
        package_8h: "8h Package",
        min: "min",
        from: "from",
        expectedKm: "Expected km (optional)",
        expectedKmPh: "km beyond included allowance are billed extra",
        executive_sedan: "Executive Sedan",
        premium_sedan: "Premium Sedan",
        vip_van: "VIP Van",
        luxury_4_seats: "Luxury · 4 seats",
        luxury_8_seats: "Luxury · 8 seats",
      },
      taxi: {
        standard: "Standard",
        hybrid: "Hybrid",
        family_7_seater: "7-seater family",
        vip: "VIP",
        family: "Family",
        seatsShort: "seats",
      },
      bus: {
        minivan: "Minivan (8–12)",
        minibus: "Minibus (14–23)",
        bus_standard: "Coach (30–55)",
      },
      truck: {
        up_to_1t: "Up to 1t",
        "1_to_3_5t": "1 – 3.5t",
        "3_5_to_7_5t": "3.5 – 7.5t",
        over_7_5t: "Over 7.5t",
        over_12t: "12+ tons",
      },
      common: {
        pricingComingSoon: "Pricing coming soon",
        edit: "Edit",
        close: "Close",
        save: "Save",
      },
      wallet: {
        title: "Wallet & Rewards",
        balance: "Available Balance",
        points: "pts",
        pointsRate: "· Earn 1 pt per $1 spent",
        topupTitle: "TOP UP",
        topup: "Top up",
        min: "Minimum $5",
        topupSuccess: "Wallet topped up ✓",
        rewardsHint: "Auto-earn points on every top-up. Redeem for future orders.",
        favorites: "SAVED PLACES",
        addFav: "Add place",
        noFavs: "No saved places yet. Add Home, Work, or Gym for one-tap booking.",
        recent: "RECENT ACTIVITY",
        topupLabel: "Wallet top-up",
        home: "Home",
        work: "Work",
        other: "Other",
        customLabel: "Custom label",
        addressPlaceholder: "Full address",
        save: "Save place",
      },
      fleet: {
        title: "My Fleet",
        empty: "No vehicles yet — add one to receive dispatches",
        count_one: "{{count}} vehicle registered",
        count_other: "{{count}} vehicles registered",
        active: "Active",
        setActive: "Set active",
        addVehicle: "Add vehicle",
        name: "Nickname",
        namePh: "e.g. Blue Camry",
        category: "Service category",
        plate: "Plate",
        color: "Color",
        model: "Model",
        modelPh: "e.g. Toyota Camry 2022",
        photo: "Vehicle photo",
        photoHint: "Customers see this exact car pulling up",
        removePhoto: "Remove photo",
        added: "Vehicle added",
        removed: "Vehicle removed",
        activated: "Active vehicle updated",
        confirmDelete: "Remove this vehicle?",
        needLabel: "Give this vehicle a name",
        needCategory: "Pick a service category",
        addFailed: "Could not add vehicle — please retry",
        activateFailed: "Could not set active vehicle — please retry",
        photoTooLarge: "Photo too large — pick one under 500KB",
        save: "Add to fleet",
      },
      support: {
        title: "Support",
        subtitle: "We're here 24/7 — chat with us or send a message.",
        contactUs: "Contact us",
        sendMessage: "Send message",
        typeMessage: "Type your message…",
        send: "Send",
        yourMessage: "Your message",
        replyFromUs: "From Drivons",
        ai: "Drivons AI",
        aiHint: "AI first-responder. Type 'human' to talk to a real agent.",
        waitingAgent: "Waiting for an agent to join…",
        agentJoined: "{{name}} has joined the chat",
        closed: "This conversation was closed. Send a new message to reopen.",
        translateShow: "Translate",
        translated: "TRANSLATED",
        showOriginal: "Show original",
      },
    },
  },
  ar: {
    translation: {
      split: {
        amountLabel: "المبلغ",
        backHome: "العودة إلى Drivons",
        button: "شارك مع صديق",
        codeLabel: "رمز التقسيم",
        copyLink: "نسخ الرابط",
        createBtn: "أنشئ رابط المشاركة",
        enterAmount: "أدخل مبلغاً صحيحاً",
        eyebrowFriend: "صديقك يطلب منك المشاركة في الدفع",
        fromRider: "من {{name}}",
        helper: "شارك رابطاً — يمكنهم دفع حصتهم دون حساب. إجمالي الرحلة: {{total}} {{cur}}",
        hint: "سيرون المبلغ عند فتح الرابط.",
        notFoundTitle: "طلب التقسيم غير موجود",
        noteLabel: "ملاحظة (اختياري)",
        notePh: "مثلاً: رحلة إلى المطار 🙏",
        noteSection: "ملاحظة",
        orderRef: "طلب",
        paidEyebrow: "تم الدفع — شكراً",
        payWithPaypal: "ادفع {{amt}} {{cur}} عبر PayPal",
        secure: "دفع PayPal آمن — لا حاجة لحساب Drivons. سيتلقى صديقك تأكيداً.",
        settledOn: "سُدد في",
        shareNow: "مشاركة",
      },
      serviceOptions: {
        chooseOption: "اختر خياراً",
      },
      shared: {
        anon: "راكب",
        badge: "رحلة تاكسي مشتركة",
        byCreator: "بدأها {{name}}",
        calculating: "جارٍ حساب توفيرك…",
        cancelCta: "إلغاء الرحلة المشتركة",
        codeCopied: "تم نسخ الرمز",
        confirmCancel: "هل تريد إلغاء هذه الرحلة المشتركة للجميع؟",
        copyCode: "نسخ الرمز",
        create: "إنشاء رحلة مشتركة",
        createOwn: "أنشئ رحلة مشتركة خاصة بك",
        created: "تم إنشاء الرحلة المشتركة — ادعُ أصدقاءك!",
        creator: "المنشئ",
        errAddressLookup: "لم يُعثر على أحد العناوين",
        errNoQuote: "احصل على تقدير أولاً",
        fareHint: "التقسيم النهائي يتكيف مع عدد الركاب الفعلي.",
        full: "مكتمل",
        invite: "ادعُ أصدقاءك",
        inviteText: "انضم إلى رحلة تاكسي Drivons المشتركة من {{from}} إلى {{to}} — بـ {{price}} {{currency}} فقط",
        joinCta: "انضم إلى الرحلة",
        joined: "أنت بالداخل! نراك في نقطة الالتقاط.",
        leaveCta: "غادر الرحلة المشتركة",
        left: "غادرت هذه الرحلة المشتركة",
        maxPax: "إجمالي المقاعد (بما فيها مقعدك)",
        notFound: "الرحلة المشتركة غير موجودة",
        notFoundHint: "قد يكون الرمز منتهياً. اطلب من المنشئ رمزاً جديداً.",
        notesLabel: "ملاحظات للركاب (اختياري)",
        notesPh: "مثلاً: رحلة إلى المطار الساعة 6 صباحاً — أحضروا هوية",
        rideCode: "رمز الرحلة",
        saveN: "وفر {{n}}% لكل شخص",
        seat: "مقعد",
        seats: "مقاعد",
        seatsLeft: "بقيت {{n}} مقاعد",
        signInFirst: "سجّل الدخول لبدء رحلة مشتركة",
        signInToJoin: "سجّل الدخول للانضمام",
        soloFare: "السعر بمفردك",
        yourSeat: "مقعدك (إذا انضم {{n}})",
        yourSeatShort: "مقعدك",
      },
      waitlist: {
        emailPlaceholder: "your@email.com",
        joinedEyebrow: "أنت مسجل في القائمة",
        socialProof: "انضم إلى {{n}} آخرين في {{country}} ينتظرون Drivons.",
      },
      saveHome: {
        saved: "تم الحفظ كـ {{label}}",
        savedEyebrow: "محفوظ",
        savedTitle: "الحجز بلمسة واحدة متاح الآن",
      },
      referralCard: {
        copiedShort: "تم النسخ",
        copyFailed: "تعذّر نسخ الرمز",
        earnedSuffix: "ربحت",
        invited: "تمت دعوتهم",
        linkCopied: "تم نسخ رابط الدعوة — الصقه في أي مكان",
        share: "مشاركة",
        shareFailed: "تعذّر فتح نافذة المشاركة",
        shareText: "انضم إليّ على Drivons — سوق الطلب الفوري لسيارات الأجرة والنقل والسحب والمزيد.",
        shareTitle: "ادعُ أصدقاءك إلى Drivons",
        yourCode: "رمزك",
      },
      driver: {
        yourDriver: "سائقك",
      },
      currency: {
        auto: "تلقائي",
        autoDesc: "تم الكشف من موقعك",
      },
      chat: {
        translate: "ترجم",
        translating: "جارٍ الترجمة…",
      },
      wallet: {
        addFav: "أضف مكاناً",
        addressPlaceholder: "العنوان",
        customLabel: "تسمية",
        favorites: "الأماكن المحفوظة",
        noFavs: "لا توجد أماكن محفوظة بعد.",
        points: "نقاط",
        pointsRate: "نقطة واحدة لكل 1$",
        rewardsHint: "احصل على نقطة ولاء واحدة عن كل 1$ تشحنه.",
        topup: "شحن عبر PayPal",
        topupCancelled: "تم إلغاء الشحن.",
        topupLabel: "شحن PayPal",
        topupOpening: "جارٍ فتح PayPal…",
        topupPending: "الشحن لم يُؤكد بعد.",
        topupProcessing: "جارٍ تأكيد الشحن عبر PayPal…",
        topupSub: "ادفع بـ PayPal، أو ببطاقة Visa · Mastercard · Amex عبر PayPal.",
        topupSuccess: "اكتمل الشحن!",
        topupTitle: "شحن",
      },
      estimate: {
        bookNow: "احجز الرحلة",
        computing: "جارٍ الحساب…",
        disclaimer: "المسافات والأوقات محسوبة عبر OSRM. قد يختلف السعر الفعلي حسب الحركة والتوقفات.",
        enterBoth: "أدخل نقطة الالتقاط والوجهة لرؤية السعر.",
        estimatedTotal: "الإجمالي التقديري",
        geoTip: "تم الكشف من عنوان IP — يحدد التسعير المحلي تلقائياً",
        minFare: "الحد الأدنى",
        myLocation: "أنا",
        perKm: "لكل كم",
        perMinute: "لكل دقيقة",
        pricingIn: "التسعير في",
        tariff1: "التعرفة 1 · نهار",
        tariff2: "التعرفة 2 · ليل",
        tariff3: "التعرفة 3 · السبت/عطلة",
        tariffTip: "التعرفة تحدد وفق تعرفة وزارة النقل الإسرائيلية السارية عند وقت الالتقاط.",
      },
      crane: {
        brBase: "الأساس (أول ساعتين)",
        brCommission: "عمولة Drivons",
        brExtraHours: "ساعات إضافية",
        brExtraKm: "كيلومترات إضافية",
        brFree: "مشمول",
        brIncluded: "الأولى",
        brPayout: "دفعة المورد",
        brTotal: "الإجمالي",
        heavy: "ثقيل",
        large: "كبير",
        small: "صغير",
      },
      common: {
        pricingComingSoon: "التسعير قريبًا",
        dismiss: "إغلاق",
        reset: "إعادة تعيين",
      },
      account: {
        changePassword: "تغيير كلمة المرور",
        changePasswordSub: "حافظ على أمان حسابك",
        deleteBtn: "حذف حسابي نهائياً",
        deleteDesc: "يؤدي هذا إلى حذف ملفك الشخصي وبياناتك الشخصية نهائياً. يُحفظ سجل الطلبات لأغراض محاسبية فقط.",
        deleteTitle: "حذف الحساب",
        deleted: "تم حذف حسابك",
        exportBtn: "تنزيل بياناتي",
        exportDesc: "قم بتنزيل ملف JSON يحتوي على ملفك الشخصي والطلبات والمدفوعات والأماكن المفضلة وطلبات الدعم.",
        exportReady: "تم تنزيل بياناتك",
        exportTitle: "تصدير بياناتي",
        pageSub: "أدر بياناتك وخصوصيتك وفق GDPR وسياسات المتاجر.",
        typeDeleteToConfirm: "اكتب DELETE للتأكيد",
        typePrompt: "اكتب DELETE للتأكيد:",
      },
      mk: {
        nav: { riders: "الركاب", drivers: "السائقون", services: "الخدمات", download: "تحميل", signin: "تسجيل الدخول" },
        hero: {
          eyebrow: "متاح بـ 6 لغات",
          h1a: "إلى أي مكان.", h1b: "لأي مهمة.",
          sub: "رحلات، توصيل، نقل ومساعدة على الطريق — Drivons يوصلك بمشغّل موثوق قريب في ثوانٍ.",
          ctaGet: "احصل على التطبيق", ctaDrivers: "قُد معنا",
          stat1: "لغات", stat2: "أنواع الخدمة", stat3: "دعم",
        },
        services: {
          eyebrow: "تطبيق واحد، احتياجات لا نهاية",
          h2: "8 خدمات، بلمسة واحدة",
          sub: "من رحلة قصيرة إلى عطل في منتصف الطريق — Drivons يرسل لك مشغّلًا موثوقًا في ثوانٍ.",
        },
        riders: {
          eyebrow: "للركاب",
          h3: "احجز في ثوانٍ. ادفع كما تريد.",
          p1: "خريطة حية + سعر مسبق — بلا مفاجآت.", p2: "نقدًا، PayPal، محفظة، أو بطاقة (عبر PayPal).", p3: "دعم بشري 24/7 بلغتك.", p4: "قيّم واترك بقشيشًا لسائقك من الفاتورة.",
          cta: "جرّب Drivons مجانًا",
        },
        drivers: {
          eyebrow: "للسائقين",
          h3: "قُد معنا. احتفظ بـ 85% من كل رحلة.",
          p1: "عمولة ثابتة 15%. لا خصومات خفية.", p2: "دفعات أسبوعية فورية إلى حسابك عبر PayPal.", p3: "اختر ساعاتك — اقبل أو ارفض كل طلب.", p4: "رحلات محجوزة، بث للتوزيع، أو عشوائي قريب — أنت تختار.",
          cta: "ابدأ الكسب",
        },
        features: {
          eyebrow: "لماذا Drivons",
          h2: "تسعير عادل. سائقون حقيقيون. بلا مفاجآت.",
          feat1t: "توزيع فوري", feat1v: "أقرب مشغّل يتلقى تنبيهًا في أقل من 3 ثوانٍ.",
          feat2t: "تتبع مباشر", feat2v: "تابع سائقك على الخريطة من الاستلام إلى الوجهة.",
          feat3t: "مشغّلون موثّقون", feat3v: "كل سائق مرخّص ومؤمَّن وخاضع لفحص الخلفية.",
          feat4t: "6 لغات", feat4v: "إنجليزية، عربية، عبرية، روسية، تركية، فرنسية — مع RTL كامل.",
        },
        dl: {
          eyebrow: "احصل على Drivons",
          h2a: "مدينتك.", h2b: "بلمسة واحدة.",
          sub: "متاح على iOS و Android. مجاني، بلا اشتراك.",
          note: "روابط المتجر ستعمل عند اعتماد التطبيق. حتى ذلك، سجّل في drivon.co.il.",
          appleLine1: "تحميل من", googleLine1: "احصل عليه من",
        },
      },
      brand: "Drivons",
      brandShort: "Drivons",
      nav: {
        request: "طلب",
        services: "الخدمات",
        how: "كيف يعمل",
        suppliers: "للمورّدين",
        signIn: "تسجيل الدخول",
        getStarted: "إنشاء حساب",
        dashboard: "لوحة التحكم",
        logout: "تسجيل الخروج",
        home: "الرئيسية",
        activity: "النشاط",
        account: "الحساب",
      },
      categories: {
        moving: "النقل والانتقال",
        moving_desc: "طواقم كاملة، شاحنات، وتغليف.",
        transport: "نقل البضائع",
        transport_desc: "مسافات طويلة ومبرّدة.",
        towing: "قطر السيارات",
        towing_desc: "خدمة قطر على مدار الساعة.",
        taxi: "تاكسي",
        taxi_desc: "رحلات عند الطلب وإدارة أسطول.",
        mechanic: "ميكانيكي متنقل",
        mechanic_desc: "فنيّون معتمدون يأتون إليك.",
        tire: "إصلاح الإطارات",
        tire_desc: "ترقيع وتبديل الإطارات في الموقع.",
        delivery: "توصيل",
        carwash: "غسيل السيارات",
        bus: "حافلة",
        bus_desc: "ميني باص (12–15 مقعدًا) أو حافلة كاملة (30–50 مقعدًا).",
        luxury: "فاخرة",
        luxury_desc: "سيدان، دفع رباعي، ليموزين، سيارات خارقة — مع أو بدون سائق.",
        crane: "نقل الرافعات",
        crane_desc: "أذرع من 12 إلى 42+ متر — رافعات متنقلة لكل مهمة.",
        limousine: "ليموزين",
        delivery_desc: "طرود وطعام وبقالة في نفس اليوم.",
      },
      landing: {
        requestCtaPlaceholder: "أين تحتاج المساعدة؟",
        requestOne: "اطلب الخدمة",
        servicesTitle: "الخدمات",
        hello: "أهلًا",
        helloBack: "مرحبًا بعودتك",
        searchPlaceholder: "ابحث عن خدمة، تاكسي، ميكانيكي…",
        popular: "الأكثر طلباً",
        popularBadge: "الأكثر طلباً",
        popularSub: "الأكثر طلباً بالقرب منك",
        walletTitle: "ادفع وانطلق",
        freeSignup: "التسجيل مجاني — تدفع عند الحجز فقط",
        bannerEyebrow: "عرض",
        bannerTitle: "احجز أسرع. وفّر أكثر.",
        bannerSubtitle: "نقدًا أو بالبطاقة · عمولة 15% فقط",
        explore: "اكتشف",
        promo1: "إرسال سريع",
        promo2: "طواقم موثّقة",
        promo3: "أحل واربح",
        featuredEyebrow: "أفضل المشغّلين",
        featuredTitle: "قريب منك",
        seeAll: "عرض الكل",
        supplierEyebrow: "للسائقين",
        supplierTitleShort: "تملك الشاحنات؟ احتفظ بالأرباح.",
        supplierSub: "إدراج مجاني · عمولة 15% فقط على الطلبات المكتملة",
        becomeSupplier: "ابدأ الكسب",
        currentLocation: "موقعك الحالي",
        location: "حدّد موقعك",
        setLocation: "اضغط لتحديد موقعك",
        locationDenied: "تم حظر الوصول للموقع. فعّله في المتصفح للعثور على مورّدين قريبين.",
        nearbyEyebrow: "قريب منك",
        nearbyTitle: "المتاحون حولك",
        sosEyebrow: "طارئ",
        sosTitle: "إطار مثقوب؟ تحتاج قطر؟",
        sosDesc: "أسرع مساعدة على الطريق. اضغط لأقرب طاقم.",
        live: "مباشر",
        heroLine1: "اطلب نقل،",
        heroLine2: "قطر، ميكانيكيين،",
        heroLine3: "توصيل.",
        heroLine4: "إرسال واحد.",
        heroSubtitle: "سوق مباشر لخدمات النقل، الشحن، القطر، التاكسي، الميكانيكي، وإصلاح الإطارات. التسجيل مجاني — ادفع نقدًا أو بالبطاقة عند الحجز.",
        heroCtaOrder: "إرسال طلب",
        heroCtaSupplier: "قُد معنا",
        stats: {
          response: "متوسط الاستجابة",
          fee: "رسم الطلب",
          free: "مجاني",
          operators: "المشغّلون",
          requests: "طلبات / شهر",
        },
        catalogEyebrow: "// كتالوج الخدمات",
        catalogTitle1: "ست فئات.",
        catalogTitle2: "بدون وسطاء.",
        browseAll: "تصفّح الكل →",
        protocol: "// البروتوكول",
        protocolTitle: "ثلاث خطوات. هذا كل شيء.",
        steps: {
          s1t: "اختر الخدمة",
          s1d: "تصفّح النقل، الشحن، القطر، التاكسي، الميكانيكي، أو الإطارات. قارن حسب التقييم والسعر والمنطقة.",
          s2t: "أرسل الطلب",
          s2d: "أدخل الاستلام والتسليم، حدّد الموعد، أضف ملاحظات. مجاني — بدون بطاقة أو التزام.",
          s3t: "يستجيب المورّد",
          s3d: "يستلم المورّد إشعارًا فوريًا ويقبل أو يرفض. تابع الحالة لحظة بلحظة.",
        },
        supplierEyebrow: "// للسائقين",
        supplierTitle1: "تملك الشاحنات؟",
        supplierTitle2: "تملك الأرباح.",
        supplierSubtitle: "أدرج خدماتك. حدّد أسعارك. احتفظ بـ 100٪ من دخلك — بدون عمولة خلال الإطلاق.",
        supplierFeat1t: "حسابات عملاء موثّقة",
        supplierFeat1d: "طلبات حقيقية من عملاء تم التحقّق منهم.",
        supplierFeat2t: "إشعارات فورية",
        supplierFeat2d: "الطلبات الجديدة تصلك على لوحتك فور إرسالها.",
        supplierFeat3t: "احتفظ بعملائك",
        supplierFeat3d: "تواصل مباشر، بدون رسوم عمولة.",
        becomeSupplier: "ابدأ الكسب →",
        avgRevenue: "متوسط الإيرادات الشهرية",
        perOperator: "لكل مشغّل نشط",
      },
      auth: {
        backToLogin: "العودة إلى تسجيل الدخول",
        busTier: "فئة الحافلة",
        changePhoto: "تغيير الصورة",
        confirmPasswordPh: "تأكيد كلمة المرور الجديدة",
        confirmPassword: "تأكيد كلمة المرور الجديدة",
        craneTonnage: "سعة الرافعة (طن)",
        currentPassword: "كلمة المرور الحالية",
        newPassword: "كلمة المرور الجديدة",
        dailyRate: "السعر اليومي",
        devLinkLabel: "رابط التطوير (بدون بريد)",
        driverProfile: "ملف السائق",
        emailPh: "you@example.com",
        forgotDesc: "أدخل بريدك الإلكتروني المسجل وسنرسل لك رابطاً لمرة واحدة لتعيين كلمة مرور جديدة.",
        forgotHint: "افحص صندوق البريد الوارد (وأيضاً الرسائل غير المرغوبة). الرابط صالح لمدة 30 دقيقة.",
        forgotPassword: "نسيت كلمة المرور؟",
        forgotSent: "إذا كان البريد مسجلاً في النظام، فقد تم إرسال رابط الاستعادة.",
        forgotTitle: "هل نسيت كلمة المرور؟",
        hourlyRate: "السعر بالساعة",
        inviteCode: "رمز الدعوة (اختياري)",
        luxuryHint: "جميع تأجيرات السيارات الفاخرة تشمل سائقاً. اترك السعر فارغاً إذا لم تكن تقدمه.",
        luxurySpecs: "سيارة فاخرة",
        newPasswordPh: "كلمة المرور الجديدة",
        noPhoto: "لا توجد صورة",
        openLink: "افتح",
        paypalResumeHint: "تابع دفع PayPal — سجّل الدخول بحساب",
        phone: "رقم الهاتف",
        primaryService: "الخدمة الرئيسية",
        pwMismatch: "كلمتا المرور غير متطابقتين",
        pwTooShort: "يجب أن تحتوي كلمة المرور على 8 أحرف على الأقل",
        pwUpdated: "تم تحديث كلمة المرور",
        resetDoneMsg: "جارٍ توجيهك إلى شاشة تسجيل الدخول…",
        resetNoToken: "رمز إعادة التعيين مفقود من الرابط",
        seatingCapacity: "عدد المقاعد",
        selectService: "اختر…",
        sendResetLink: "إرسال رابط الاستعادة",
        setNewDesc: "اختر كلمة مرور قوية — 8 أحرف على الأقل.",
        setNewPassword: "تعيين كلمة مرور جديدة",
        shownToCustomers: "معروض للعملاء",
        signInNow: "سجّل الدخول الآن ←",
        taxiClass: "نوع سيارة الأجرة",
        truckTonnage: "سعة الشاحنة (طن)",
        updatePassword: "تحديث كلمة المرور",
        uploadPhoto: "رفع صورة",
        vehicle: "مركبتك",
        signIn: "تسجيل الدخول",
        signInSub: "ادخل غرفة الإرسال",
        signInSubDriver: "قد معنا — ابدأ الكسب.",
        signInPassenger: "دخول كراكب",
        signInDriver: "دخول كسائق",
        rolePassenger: "راكب",
        roleDriver: "سائق",
        noDriverAccount: "سائق جديد؟",
        signUpDriver: "سجل للقيادة",
        roleMismatchDriver: "هذا حساب سائق — سنسجّل دخولك كسائق.",
        roleMismatchPassenger: "هذا حساب راكب — سنسجّل دخولك كراكب.",
        createAccount: "إنشاء حساب",
        createSub: "انضم إلى الشبكة",
        email: "البريد الإلكتروني",
        password: "كلمة المرور",
        name: "الاسم الكامل",
        noAccount: "لا تملك حسابًا؟",
        signUp: "أنشئ حسابًا",
        haveAccount: "لديك حساب؟",
        iAmCustomer: "أنا عميل",
        iAmSupplier: "أنا مورّد",
        continueWithGoogle: "المتابعة مع جوجل",
        or: "أو",
        welcome: "أهلًا بعودتك",
        accountCreated: "تم إنشاء الحساب",
        freeSignupNote: "التسجيل مجاني. لا حاجة لبطاقة. تدفع فقط عند حجز خدمة — نقدًا عند الوصول أو بالبطاقة.",
      },
      services: {
        categorySub: "موردون قريبون منك جاهزون للمساعدة",
        eyebrow: "// كل الخدمات",
        title: "أقرب طاقم، عند الطلب",
        categoryEyebrow: "//",
        operatorsAvailable: "مشغّلون متاحون",
        loading: "جاري تحميل المشغّلين…",
        empty: "لا يوجد مشغّلون قريبون",
        emptyDesc: "حاول توسيع نطاق البحث أو اختيار فئة أخرى.",
        all: "الكل",
        by: "بواسطة",
        per: "لكل",
        book: "اطلب",
        sortedNearest: "الأقرب أولًا",
      },
      booking: {
        eyebrow: "// طلب خدمة",
        title: "أين نرسل المساعدة؟",
        details: "التفاصيل",
        route: "المسار",
        pickup: "الاستلام",
        pickupPlaceholder: "موقعك الحالي",
        dropoff: "التسليم",
        dropoffPlaceholder: "إلى أين؟",
        useMyLocation: "استخدم موقعي",
        optional: "(اختياري)",
        quantity: "الكمية",
        scheduled: "الموعد",
        notes: "ملاحظات",
        notesPlaceholder: "تعليمات خاصة، رقم الطابق، رمز البوابة…",
        summary: "ملخص الطلب",
        refPrice: "السعر المرجعي",
        category: "الفئة",
        estimate: "التقدير",
        finalPrice: "السعر النهائي يؤكده المورّد",
        sendRequest: "إرسال الطلب",
        freeAlert: "مجاني · يتم إشعار المورّد فورًا",
        requestSent: "تم الإرسال — تم إشعار المورّد",
        pickupRequired: "عنوان الاستلام مطلوب",
        onlyCustomers: "الحسابات العميلة فقط يمكنها الطلب",
      },
      dashboard: {
        myRequests: "طلباتي",
        supplierHq: "مقر المورّد",
        adminConsole: "لوحة المشرف",
        totalRequests: "إجمالي الطلبات",
        active: "نشط",
        completed: "مكتمل",
        newRequests: "طلبات جديدة",
        listings: "الإعلانات",
        users: "المستخدمون",
        suppliers: "المورّدون",
        requests: "الطلبات",
        recent: "أحدث الطلبات",
        incoming: "الطلبات الواردة",
        myListings: "إعلاناتي",
        allRequests: "كل الطلبات",
        noRequests: "لا توجد طلبات بعد",
        noListings: "أنشئ أول إعلان →",
        browse: "تصفّح الخدمات →",
        newListing: "جديد",
        newListingTitle: "إعلان جديد",
        listingCreated: "تم إنشاء الإعلان",
        verify: "توثيق",
        markAllViewed: "تعليم الكل مقروء",
        newRequestsBanner: "طلبات جديدة",
        newRequestsBannerSub: "عملاء ينتظرون ردّك.",
        accept: "قبول الطلب",
        decline: "رفض",
        startJob: "بدء العمل",
        markComplete: "تم الإنجاز",
        supplierLabel: "المورّد",
        customerLabel: "العميل",
        newBadge: "جديد",
      },
      footer: {
        privacy: "الخصوصية",
        support: "الدعم",
        terms: "الشروط",
        services: "الخدمات",
        company: "الشركة",
        ops: "التشغيل",
        about: "من نحن",
        careers: "الوظائف",
        contact: "تواصل",
        status: "الحالة:",
        operational: "قيد التشغيل",
        dispatch: "إرسال 24/7",
        tagline: "سوق خدمات صناعية. مباشرة من المشغّلين.",
        copyright: "© 2026 الخدمة السريعة — بُني للطواقم العاملة",
      },
      payment: {
        applepayHint: "ستُنقل إلى PayPal للتفويض عبر Apple Pay.",
        balance: "الرصيد",
        cardChip: "بطاقة",
        cardViaPaypal: "Visa · Mastercard · Amex مقبولة — تُعالج بأمان عبر PayPal. لا حاجة لحساب PayPal.",
        googlepayHint: "ستُنقل إلى PayPal للتفويض عبر Google Pay.",
        insufficient: "غير كافٍ",
        payWithWallet: "الدفع بالمحفظة",
        topUp: "شحن",
        wallet: "المحفظة",
        method: "طريقة الدفع",
        cash: "دفع نقدًا عند الوصول",
        cashDesc: "ادفع للمشغّل مباشرة عند وصوله.",
        card: "بطاقة · Apple Pay · Google Pay",
        cardDesc: "ادفع بأمان — Apple Pay أو Google Pay أو أي بطاقة.",
        payNow: "ادفع الآن",
        payLater: "إرسال الطلب",
        confirmPayment: "جاري تأكيد الدفع…",
        paid: "تم الدفع والتأكيد",
        paidDesc: "تم إشعار المورّد. تابع الحالة في لوحتك.",
        cancelled: "تم الإلغاء",
        cancelledDesc: "تم إلغاء الدفع. لم يتم تقديم الطلب.",
        failed: "مشكلة في الدفع",
        failedDesc: "حاول مرة أخرى أو تواصل مع الدعم.",
        markCashPaid: "تأكيد استلام النقد",
        cashPaid: "تم استلام النقد", walletPaid: "المحفظة مدفوعة", walletPending: "المحفظة قيد الانتظار",
        cardPaid: "تم الدفع بالبطاقة",
        awaitingCash: "بانتظار النقد",
        awaitingCard: "بانتظار الدفع",
        walletInsufficient: "رصيد المحفظة غير كافٍ لهذه الرحلة.",
        receipt: {
          eyebrow: "تم استلام الدفع",
          thanks: "شكرًا — سائقك جاهز.",
          tripSection: "رحلتك",
          pickup: "الاستلام",
          dropoff: "التوصيل",
          breakdownSection: "تفصيل الأجرة",
          baseFare: "الأجرة الأساسية",
          distanceCharge: "المسافة",
          timeCharge: "الوقت",
          surge: "زيادة الطلب",
          total: "الإجمالي",
          txSection: "مرجع المعاملة",
          captureId: "معرّف العملية",
          copy: "نسخ",
          copied: "تم النسخ",
          captureCopied: "تم نسخ رقم المعاملة",
          viewOrders: "طلباتي",
          bookAnother: "احجز مرة أخرى",
        },
        paypal: {
          signInAsOriginal: "سجّل الدخول باسم {{email}}",
          wrongUser: "سجّل الدخول لإتمام الدفع",
          wrongUserDesc: "بدأ هذا الدفع من حساب آخر:",
          wrongUserSafety: "تفويض PayPal آمن. لم يتم تحويل أي أموال. سجّل الدخول بالحساب أعلاه لإكماله.",
          confirming: "جاري تأكيد الدفع عبر PayPal…",
          failed: "فشل الدفع",
          retry: "حاول مرة أخرى",
        },
      },
      request: {
        paypalConvert: {
          charge: "رسوم PayPal",
          confirm: "المتابعة بهذا التحويل؟",
          fare: "سعر رحلتك",
          rate: "السعر",
          source: "المصدر",
        },
        fareCalcPending: "سيتم حساب السعر بعد اختيار الوجهة",
        anomalyAutoFix: "تصحيح تلقائي للوجهة",
        anomalyCross: "الرحلة تعبر دولاً ({{km}} كم). قد يكون أحد العناوين خاطئاً.",
        anomalyEyebrow: "رحلة طويلة — تأكد",
        anomalyFar: "الرحلة بطول {{km}} كم — أطول بكثير من معظم الرحلات. تحقق من العنوانين.",
        anomalyFixDropoff: "تصحيح الوجهة",
        anomalyFixPickup: "تصحيح الالتقاط",
        anomalyFixed: "تم تصحيح الوجهة إلى موقع محلي",
        anomalyNoFix: "لم يُعثر على تطابق أقرب — جرّب الاختيار يدوياً",
        codeHint: "سيطلب منك السائق هذا الرمز المكوّن من 4 أرقام قبل بدء الرحلة.",
        craneHours: "مدة العمل (ساعات)",
        craneHoursHint: "الحد الأدنى ساعتان · الساعتان الأوليان مشمولتان في الأساس",
        freqDaily: "عادة يومية",
        freqMonth: "{{n}}× هذا الشهر",
        freqTooltip: "كم مرة تسلك هذه الرحلة",
        freqWeekly: "{{n}}× أسبوعياً",
        fxUnavailable: "خدمة أسعار الصرف غير متاحة. اختر وسيلة دفع أخرى.",
        istanbulTaxiTariffNotice: "تسعير سيارات الأجرة Drivons في إسطنبول يتبع التعرفة الرسمية.",
        luxuryBilling: "نموذج الفوترة",
        noLuxuryClasses: "فئات السيارات الفاخرة غير متاحة في هذه الدولة حالياً.",
        orPickCustom: "أو اختر وقتاً مخصصاً",
        paypalCurrencyUnsupported: "PayPal غير متاح للمدفوعات بعملة {{cur}}. اختر وسيلة دفع أخرى.",
        pickBusClass: "اختر نوع الحافلة",
        pinAdjusted: "تم تحديث نقطة الالتقاط",
        pinDragHint: "اسحب الدبوس لضبط نقطة الالتقاط بدقة",
        repeatBtn: "انطلق",
        repeatEyebrow: "أتريد إعادة هذه الرحلة؟",
        selectOptionHint: "اختر خياراً أدناه لرؤية السعر",
        shareRide: "مشاركة الرحلة",
        showThisCode: "أظهر هذا الرمز للسائق",
        smartSuggest: "اقتراح ذكي",
        suggestSwitchTo: "جرّب {{cat}} لهذه الرحلة ←",
        tomorrow: "غداً",
        tripVerified: "تم التحقق من الرحلة",
        eyebrow: "عند الطلب",
        title: "اطلب خدمة",
        serviceType: "ما الذي تحتاجه؟",
        pickup: "موقع الاستلام",
        pickupPh: "أين أنت؟",
        dropoff: "إلى أين؟",
        dropoffPh: "الوجهة",
        optional: "اختياري",
        gps: "GPS",
        cta: "اطلب الآن",
        note: "سيتم إخطار أقرب السائقين المتاحين. أول من يقبل يصبح سائقك.",
        farePreview: "تقدير التكلفة",
        setPickupFirst: "حدد موقع الاستلام لرؤية التقدير",
        fareUnavailable: "التسعير غير متاح لهذا الموقع حاليًا.",
        flatFare: "سعر ثابت",
        base: "الأساس",
        addDropoffForDistance: "أضف وجهة لرؤية التقدير حسب المسافة",
        looking: "جارٍ البحث عن سائق قريب…",
        noDrivers: "لم يستجب أي سائق بعد",
        driversAlerted: "تم إخطار السائقين",
        stillDeciding: "لا يزالون يقررون",
        allDeclined: "رفض أو تجاهل كل السائقين القريبين. حاول البث لسائقين إضافيين أو ألغِ وحاول لاحقًا.",
        stillWaiting: "لا يزال هناك انتظار لقبول سائق. يمكنك الانتظار أو إعادة البث أو الإلغاء.",
        rebroadcast: "أعد الإخطار للسائقين القريبين",
        rebroadcasted: "تمت إعادة إخطار السائقين القريبين",
        cancel: "إلغاء الطلب",
        cancelled: "تم إلغاء الطلب",
        driverFound: "تم تعيين السائق!",
        completed: "اكتملت الرحلة",
        viewInDashboard: "عرض في لوحة التحكم",
        locationDenied: "تم رفض إذن الموقع",
        locDenied: "تم رفض إذن الموقع. فعّله من إعدادات جهازك / المتصفح ثم حاول مجددًا.",
        locUnavailable: "تعذّر الحصول على إشارة GPS. حاول في الهواء الطلق أو أدخل العنوان يدويًا.",
        locTimeout: "انتهت مهلة طلب الموقع. حاول مرة أخرى.",
        locInsecure: "يتطلب تحديد الموقع اتصالًا آمنًا (HTTPS). يرجى إعادة التحميل.",
        locGeneric: "تعذّر تحديد موقعك. الرجاء إدخال عنوان الاستلام يدويًا.",
        pickCategory: "اختر فئة الخدمة",
        needPickup: "حدد موقع الاستلام",
        sent: "تم إرسال الطلب — جارٍ البحث عن سائق…",
        pickTaxiClass: "اختر فئة التاكسي",
        pickTruckBand: "الحد الأدنى لسعة الشاحنة",
        anyCapacity: "أي",
        when: "متى تحتاجه؟",
        now: "الآن",
        nowHint: "إرسال فوري",
        later: "جدولة لاحقاً",
        laterHint: "احجز لموعد مستقبلي",
        pickDateTime: "التاريخ والوقت",
        pickWhen: "اختر تاريخاً ووقتاً",
        pickFuture: "اختر وقتاً بعد 5 دقائق من الآن على الأقل",
        scheduleDispatchHint: "سنبدأ إرسال السائقين قبل ~10 دقائق من موعد الحجز.",
        scheduled: "تمت الجدولة — سنرسل سائقاً قرب موعد الحجز",
        ctaSchedule: "جدولة الرحلة",
        noteScheduled: "سنطابق سائقاً قريباً قبل ~10 دقائق من موعد الحجز.",
        stops: "محطات",
        addStop: "إضافة محطة",
        stopPh: "عنوان المحطة",
        stopsHint: "أضف محطات وسيطة إذا احتجت أن يمر السائق للاستلام أو التوصيل في الطريق.",
        removeStop: "إزالة المحطة",
        useMyLocation: "استخدام موقعي",
        gps: "GPS",
        optional: "اختياري",
        locationDenied: "تم رفض إذن الموقع",
        back: "رجوع",
        driverNearby: "سائق قريب",
        driversNearby: "سائقون قريبون",
        arrivesIn: "يصل خلال",
        minShort: "د",
        away: "بعيد",
        reserve: "احجز",
        ctaChoose: "اطلب",
        driverNotes: "ملاحظات للسائق",
        driverNotesPh: "أي شيء ينبغي للسائق معرفته (كود البوابة، مكان اللقاء، أغراض هشّة…)",
        luxuryStyle: "نوع الهيكل",
        luxuryRailTitle: "السيارات الفاخرة القريبة منك",
        noLuxuryNearby: "لا تتوفر سيارات فاخرة في منطقتك حاليًا — جرّب توسيع نطاق الاستلام أو عد قريبًا.",
        luxuryVehicle: "سيارة فاخرة",
        discountCode: "كود الخصم",
        discountPh: "أدخل الكود (مثال: WELCOME10)",
        discountApplied: "تم تطبيق الخصم",
        newTotal: "الإجمالي الجديد",
        apply: "تطبيق",
        tireOptions: "نوع خدمة الإطارات",
        tireSizePh: "قياس الإطار (مثال: 205/55 R16)",
        tireSizeHint: "مشاركة قياس الإطار تساعد المزود على إحضار البديل المناسب.",
        carwashOptions: "نوع الغسيل",
        serviceOptions: {
          carwash: {
            exterior: "غسيل خارجي",
            exterior_interior: "خارجي + داخلي",
            premium: "غسيل بريميوم",
          },
          delivery: {
            motorcycle: "دراجة نارية",
            car: "سيارة",
          },
          moving: {
            small_van:          "فان صغير",
            medium_truck:       "شاحنة متوسطة",
            large_truck:        "شاحنة كبيرة",
            xl_truck:           "شاحنة ثقيلة",
            refrigerated_van:   "فان تبريد",
            refrigerated_truck: "شاحنة تبريد",
          },
          moving_desc: {
            small_van:          "حتى ~1 طن · 4م³ — أغراض قليلة، أعمال صغيرة",
            medium_truck:       "حتى ~3.5 طن · 15م³ — شقق 2-3 غرف",
            large_truck:        "حتى ~7.5 طن · 35م³ — شقق 4+ غرف، تجاري",
            xl_truck:           "12 طن+ · 60م³+ — بضائع تجارية ثقيلة",
            refrigerated_van:   "❄ حتى ~1 طن · 4م³ · 2-8°م — طعام، مطاعم",
            refrigerated_truck: "❄ حتى ~3.5 طن · 15م³ · 2-8°م — سوبرماركت، موردون",
          },
        },
        craneBand: "سعة الرافعة",
        luxuryMode: "مع سائق أم بدون",
        luxuryModelPh: "الموديل المفضل (مثال: رولز رويس، لامبورغيني)",
        faultNote: "وصف العطل",
        faultNotePh: "مثال: السيارة لا تبدأ، مصباح تحذير، صوت غريب…",
        deliveryDetails: "تفاصيل عنوان التوصيل",
        apartment: "رقم الشقة",
        floor: "الطابق",
        building: "المبنى / البلوك",
        gateCode: "كود البوابة (إن وُجد)",
        contactPhone: "هاتف المستلم",
        leaveAtDoor: "اتركه عند الباب",
        leaveInLobby: "اتركه في الاستقبال",
        handToRecipient: "سلّمه للمستلم",
      },
      luxury: {
        ladderDiscount: "خصم استئجار طويل",
        newDriver: "سائق جديد",
        trips: "رحلات",
        with_driver: "مع سائق",
        without_driver: "قيادة ذاتية",
        style_sedan: "سيدان",
        style_suv: "دفع رباعي",
        style_limousine: "ليموزين",
        style_supercar: "سيارة خارقة",
        style_convertible: "كابريوليه",
        per_trip: "لكل رحلة",
        hourly: "بالساعة",
        daily: "باليوم",
        hr: "ساعة",
        day: "يوم",
        hours: "الساعات",
        days: "الأيام",
        chooseClass: "اختر الفئة",
        billing: "الفوترة",
        package_4h: "باقة 4 ساعات",
        package_8h: "باقة 8 ساعات",
        min: "الحد الأدنى",
        from: "من",
        expectedKm: "الكيلومترات المتوقعة (اختياري)",
        expectedKmPh: "الكيلومترات الزائدة عن الحد المسموح تُحسب بشكل إضافي",
        executive_sedan: "سيدان تنفيذي",
        premium_sedan: "سيدان بريميوم",
        vip_van: "فان VIP",
        luxury_4_seats: "فاخرة · 4 مقاعد",
        luxury_8_seats: "فاخرة · 8 مقاعد",
      },
      fleet: {
        title: "أسطولي",
        empty: "لا توجد مركبات بعد — أضف واحدة لتلقّي الطلبات",
        count_one: "مركبة {{count}} مسجّلة",
        count_other: "{{count}} مركبات مسجّلة",
        active: "نشطة",
        setActive: "تعيين كنشطة",
        addVehicle: "إضافة مركبة",
        name: "الاسم المستعار",
        namePh: "مثال: كامري زرقاء",
        category: "فئة الخدمة",
        plate: "اللوحة",
        color: "اللون",
        model: "الموديل",
        modelPh: "مثال: تويوتا كامري 2022",
        photo: "صورة المركبة",
        photoHint: "سيرى العملاء نفس هذه السيارة تصل إليهم",
        removePhoto: "إزالة الصورة",
        added: "تمت إضافة المركبة",
        removed: "تمت إزالة المركبة",
        activated: "تم تحديث المركبة النشطة",
        confirmDelete: "هل تريد إزالة هذه المركبة؟",
        needLabel: "أعطِ هذه المركبة اسمًا",
        needCategory: "اختر فئة الخدمة",
        addFailed: "تعذّرت إضافة المركبة — حاول مجددًا",
        activateFailed: "تعذّر تعيين المركبة النشطة — حاول مجددًا",
        photoTooLarge: "الصورة كبيرة جدًا — اختر واحدة أقل من 500 كيلوبايت",
        save: "أضف إلى الأسطول",
      },
      support: {
        chatEmpty: "أرسل لنا رسالة — سيرد عضو من الفريق هنا.",
        chatTitle: "الدردشة مع الدعم",
        escalateHint: "يجيب البوت على الأسئلة الشائعة. تحتاج إلى إنسان؟",
        faqTitle: "الأسئلة الشائعة",
        footer: "عادةً نرد خلال بضع ساعات.",
        intro: "نحن هنا 24/7. تحدث مع فريقنا أدناه أو راسلنا بالبريد وسنرد عليك.",
        placeholder: "اكتب رسالتك…",
        signInHint: "لبدء الدردشة مع فريقنا.",
        stateAgentOnline: "الوكيل متصل",
        stateBot: "بوت",
        stateClosed: "انتهت الجلسة",
        stateWaiting: "بانتظار الوكيل…",
        talkToAgent: "تحدث مع وكيل",
        title: "الدعم",
        subtitle: "نحن هنا على مدار الساعة — تحدث معنا أو أرسل رسالة.",
        contactUs: "تواصل معنا",
        sendMessage: "إرسال رسالة",
        typeMessage: "اكتب رسالتك…",
        send: "إرسال",
        yourMessage: "رسالتك",
        replyFromUs: "من الخدمة السريعة",
        ai: "مساعد الخدمة السريعة",
        aiHint: "الردّ الأوّلي بالذكاء الاصطناعي. اكتب 'موظف' للتحدث إلى شخص حقيقي.",
        waitingAgent: "بانتظار انضمام موظف…",
        agentJoined: "انضم {{name}} إلى المحادثة",
        closed: "أُغلقت هذه المحادثة. أرسل رسالة جديدة لإعادة فتحها.",
        translateShow: "ترجم",
        translated: "مترجَم",
        showOriginal: "عرض الأصلي",
      },
      rating: {
        rateService: "قيّم هذه الخدمة",
        title: "كيف كانت التجربة؟",
        subtitle: "تقييمك يساعد العملاء الآخرين في اختيار أفضل المشغّلين.",
        commentPlaceholder: "اختياري: اترك تعليقًا للمشغّل…",
        submit: "إرسال التقييم",
        thanks: "شكرًا على مراجعتك!",
      },
      taxi: {
        family: "عائلي",
        standard: "عادي",
        hybrid: "هجين",
        family_7_seater: "عائلي 7 مقاعد",
        vip: "VIP",
        seatsShort: "مقاعد",
      },
      truck: {
        up_to_1t: "حتى 1 طن",
        "1_to_3_5t": "1 - 3.5 طن",
        "3_5_to_7_5t": "3.5 - 7.5 طن",
        over_7_5t: "أكثر من 7.5 طن",
        over_12t: "أكثر من 12 طناً",
      },
      common: { edit: "تحرير", close: "إغلاق", save: "حفظ" },
      language: "اللغة",
    },
  },
  he: {
    translation: {
      split: {
        amountLabel: "סכום",
        backHome: "חזרה ל־Drivons",
        button: "פצל עם חבר",
        codeLabel: "קוד חלוקה",
        copyLink: "העתק קישור",
        createBtn: "צור קישור לשיתוף",
        enterAmount: "הזן סכום תקין",
        eyebrowFriend: "חבר שלך מבקש שתשתתף",
        fromRider: "מאת {{name}}",
        helper: "שתף קישור — הם יוכלו לשלם את חלקם ללא חשבון. סה״כ הנסיעה: {{total}} {{cur}}",
        hint: "הם יראו את הסכום כשיפתחו את הקישור.",
        notFoundTitle: "בקשת החלוקה לא נמצאה",
        noteLabel: "הערה (אופציונלי)",
        notePh: "לדוגמה: נסיעה לנתב\"ג 🙏",
        noteSection: "הערה",
        orderRef: "הזמנה",
        paidEyebrow: "שולם — תודה",
        payWithPaypal: "שלם {{amt}} {{cur}} עם PayPal",
        secure: "סליקת PayPal מאובטחת — ללא צורך בחשבון Drivons. חברך יקבל אישור.",
        settledOn: "יושב ב־",
        shareNow: "שתף",
      },
      serviceOptions: {
        chooseOption: "בחר אפשרות",
      },
      shared: {
        anon: "נוסע",
        badge: "נסיעת מונית משותפת",
        byCreator: "יזם על ידי {{name}}",
        calculating: "מחשב את החיסכון שלך…",
        cancelCta: "ביטול הנסיעה המשותפת",
        codeCopied: "הקוד הועתק",
        confirmCancel: "לבטל את הנסיעה המשותפת עבור כולם?",
        copyCode: "העתק קוד",
        create: "יצירת נסיעה משותפת",
        createOwn: "צור נסיעה משותפת משלך",
        created: "נסיעה משותפת נוצרה — הזמן את החברים שלך!",
        creator: "יוצר",
        errAddressLookup: "לא נמצאה אחת מהכתובות",
        errNoQuote: "קבל הערכת מחיר קודם",
        fareHint: "החלוקה הסופית מותאמת לפי מספר הנוסעים שבפועל עלו.",
        full: "מלא",
        invite: "הזמן חברים",
        inviteText: "הצטרף לנסיעת המונית המשותפת שלי ב־Drivons מ־{{from}} ל־{{to}} — רק {{price}} {{currency}}",
        joinCta: "הצטרף לנסיעה",
        joined: "נכנסת! נתראה בנקודת האיסוף.",
        leaveCta: "עזוב את הנסיעה המשותפת",
        left: "עזבת את הנסיעה המשותפת",
        maxPax: "סה״כ מקומות (כולל אותך)",
        notFound: "הנסיעה המשותפת לא נמצאה",
        notFoundHint: "ייתכן שהקוד פג. בקש מהיוצר קוד חדש.",
        notesLabel: "הערות לנוסעים (אופציונלי)",
        notesPh: "לדוגמה: נסיעה לנתב\"ג ב־06:00 — נא להביא תעודה",
        rideCode: "קוד נסיעה",
        saveN: "חסוך {{n}}% לכל אחד",
        seat: "מקום",
        seats: "מקומות",
        seatsLeft: "נותרו {{n}} מקומות",
        signInFirst: "התחבר כדי לפתוח נסיעה משותפת",
        signInToJoin: "התחבר כדי להצטרף",
        soloFare: "מחיר בנפרד",
        yourSeat: "המקום שלך (אם יצטרפו {{n}})",
        yourSeatShort: "המקום שלך",
      },
      waitlist: {
        emailPlaceholder: "your@email.com",
        joinedEyebrow: "אתה ברשימה",
        socialProof: "הצטרף ל־{{n}} נוספים ב־{{country}} שממתינים ל־Drivons.",
      },
      saveHome: {
        saved: "נשמר כ־{{label}}",
        savedEyebrow: "נשמר",
        savedTitle: "הזמנה בלחיצה אחת מוכנה",
      },
      referralCard: {
        copiedShort: "הועתק",
        copyFailed: "לא ניתן להעתיק את הקוד",
        earnedSuffix: "הרווחת",
        invited: "הוזמנו",
        linkCopied: "קישור ההזמנה הועתק — הדבק בכל מקום",
        share: "שתף",
        shareFailed: "לא ניתן לפתוח את חלון השיתוף",
        shareText: "הצטרף אליי ל־Drivons — הפלטפורמה למוניות, הובלות, גרירה ועוד.",
        shareTitle: "הזמן חברים ל־Drivons",
        yourCode: "הקוד שלך",
      },
      driver: {
        yourDriver: "הנהג שלך",
      },
      currency: {
        auto: "אוטומטי",
        autoDesc: "מזוהה לפי המיקום שלך",
      },
      chat: {
        translate: "תרגם",
        translating: "מתרגם…",
      },
      wallet: {
        addFav: "הוסף מקום",
        addressPlaceholder: "כתובת",
        customLabel: "תווית",
        favorites: "מקומות שמורים",
        noFavs: "אין עדיין מקומות שמורים.",
        points: "נקודות",
        pointsRate: "1 נקודה לכל 1$",
        rewardsHint: "צבור נקודת נאמנות אחת על כל 1$ שאתה טוען.",
        topup: "טעינה דרך PayPal",
        topupCancelled: "הטעינה בוטלה.",
        topupLabel: "טעינה דרך PayPal",
        topupOpening: "פותח את PayPal…",
        topupPending: "הטעינה טרם אושרה.",
        topupProcessing: "מאשר את הטעינה מול PayPal…",
        topupSub: "שלם ב־PayPal, או ב־Visa · Mastercard · Amex דרך תהליך הסליקה של PayPal.",
        topupSuccess: "הטעינה הושלמה!",
        topupTitle: "טעינה",
      },
      estimate: {
        bookNow: "הזמן את הנסיעה",
        computing: "מחשב…",
        disclaimer: "המרחקים והזמנים מחושבים באמצעות ניתוב OSRM. החיוב בפועל עשוי להשתנות בהתאם לתנועה בכביש ולעצירות.",
        enterBoth: "הזן איסוף ויעד כדי לראות מחיר.",
        estimatedTotal: "הערכת סה״כ",
        geoTip: "זוהה מכתובת ה־IP שלך — בוחר תמחור מקומי אוטומטית",
        minFare: "מינימום",
        myLocation: "אני",
        perKm: "לק״מ",
        perMinute: "לדקה",
        pricingIn: "תמחור ב־",
        tariff1: "תעריף 1 · יום",
        tariff2: "תעריף 2 · לילה",
        tariff3: "תעריף 3 · שבת/חג",
        tariffTip: "התעריף נקבע על פי תעריפון משרד התחבורה של ישראל התקף בזמן האיסוף.",
      },
      crane: {
        brBase: "בסיס (שעתיים ראשונות)",
        brCommission: "עמלת Drivons",
        brExtraHours: "שעות נוספות",
        brExtraKm: "ק״מ נוספים",
        brFree: "כלול",
        brIncluded: "ראשונים",
        brPayout: "תשלום לספק",
        brTotal: "סה״כ",
        heavy: "כבד",
        large: "גדול",
        small: "קומפקטי",
      },
      common: {
        pricingComingSoon: "התמחור בקרוב",
        dismiss: "סגור",
        reset: "איפוס",
      },
      account: {
        changePassword: "החלפת סיסמה",
        changePasswordSub: "שמור על חשבונך מאובטח",
        deleteBtn: "מחיקת החשבון לצמיתות",
        deleteDesc: "פעולה זו מוחקת לצמיתות את הפרופיל ואת הנתונים האישיים שלך. היסטוריית ההזמנות נשמרת לצורכי חשבונאות בלבד.",
        deleteTitle: "מחיקת חשבון",
        deleted: "החשבון שלך נמחק",
        exportBtn: "הורדת הנתונים שלי",
        exportDesc: "הורד קובץ JSON המכיל את הפרופיל, ההזמנות, התשלומים, המקומות המועדפים והפניות התמיכה שלך.",
        exportReady: "הנתונים שלך הורדו",
        exportTitle: "ייצוא הנתונים שלי",
        pageSub: "נהל את הנתונים והפרטיות שלך במסגרת GDPR ומדיניות החנויות.",
        typeDeleteToConfirm: "הקלד DELETE לאישור",
        typePrompt: "הקלד DELETE לאישור:",
      },
      mk: {
        nav: { riders: "נוסעים", drivers: "נהגים", services: "שירותים", download: "הורדה", signin: "התחברות" },
        hero: {
          eyebrow: "פעיל ב-6 שפות",
          h1a: "לכל מקום.", h1b: "לכל צורך.",
          sub: "נסיעות, משלוחים, הובלות ועזרה בכביש — Drivons מחבר אותך למפעיל מאומת בסביבה תוך שניות.",
          ctaGet: "הורד את האפליקציה", ctaDrivers: "לנהג איתנו",
          stat1: "שפות", stat2: "סוגי שירות", stat3: "תמיכה",
        },
        services: {
          eyebrow: "אפליקציה אחת, מלא צרכים",
          h2: "8 שירותים, בהקשה אחת",
          sub: "מנסיעה קצרה ועד תקלה באמצע הובלה — Drivons שולח אליך מפעיל מאומת תוך שניות.",
        },
        riders: {
          eyebrow: "לנוסעים",
          h3: "הזמנה בשניות. תשלום איך שאתה רוצה.",
          p1: "מפה חיה + מחיר מראש — בלי הפתעות במונה.", p2: "מזומן, PayPal, ארנק, או כרטיס (דרך PayPal).", p3: "תמיכה אנושית 24/7 בשפה שלך.", p4: "דירוג וטיפ לנהג ישירות מהקבלה.",
          cta: "נסה את Drivons בחינם",
        },
        drivers: {
          eyebrow: "לנהגים",
          h3: "לנהג איתנו. שמור 85% מכל נסיעה.",
          p1: "עמלת פלטפורמה קבועה של 15%. בלי הפתעות.", p2: "תשלום שבועי מיידי לחשבון דרך PayPal.", p3: "בחר את השעות שלך — אשר או דחה כל בקשה.", p4: "נסיעות מוזמנות, dispatch רחב, או אקראי קרוב — אתה בוחר.",
          cta: "התחל להרוויח",
        },
        features: {
          eyebrow: "למה Drivons",
          h2: "תמחור הוגן. נהגים אמיתיים. בלי הפתעות.",
          feat1t: "שיגור מיידי", feat1v: "המפעיל הקרוב מקבל התראה בפחות מ-3 שניות.",
          feat2t: "מעקב בזמן אמת", feat2v: "עקוב אחר הנהג במפה מרגע האיסוף ועד היעד.",
          feat3t: "מפעילים מאומתים", feat3v: "כל נהג מורשה, מבוטח ועובר בדיקת רקע.",
          feat4t: "6 שפות", feat4v: "אנגלית, ערבית, עברית, רוסית, טורקית, צרפתית — עם RTL מלא.",
        },
        dl: {
          eyebrow: "הורד את Drivons",
          h2a: "העיר שלך.", h2b: "בהקשה אחת.",
          sub: "זמין ב-iOS ואנדרואיד. בחינם, בלי מנוי.",
          note: "קישורי החנות יופעלו כשהאפליקציה תאושר. בינתיים, הירשם ב-drivon.co.il.",
          appleLine1: "הורדה מ־", googleLine1: "קבל ב־",
        },
      },
      brand: "Drivons",
      nav: {
        request: "הזמנה",
        services: "שירותים",
        how: "איך זה עובד",
        suppliers: "לספקים",
        signIn: "התחברות",
        getStarted: "הרשמה",
        dashboard: "לוח בקרה",
        logout: "יציאה",
        home: "בית",
        activity: "פעילות",
        account: "חשבון",
        about: "אודות",
        pricing: "מחירים",
        contact: "צור קשר",
      },
      categories: {
        moving: "הובלה, העברה ומטענים",
        moving_desc: "צוותים מלאים, משאיות, אריזה.",
        transport: "הובלת מטענים",
        transport_desc: "למרחקים ארוכים, מקורר.",
        towing: "גרירה",
        towing_desc: "גרירה 24/7 בפלטבד וויל‑ליפט.",
        taxi: "מונית",
        taxi_desc: "נסיעות לפי דרישה וניהול צי.",
        mechanic: "מוסכניק נייד",
        mechanic_desc: "מוסמכים שמגיעים אליך.",
        tire: "פנצ'ריה",
        tire_desc: "טלאי, פקק והחלפת גלגלים בשטח.",
        delivery: "משלוחים",
        carwash: "שטיפת רכב",
        bus: "אוטובוס",
        bus_desc: "מיניבוס (12–15 מקומות) או אוטובוס מלא (30–50 מקומות).",
        luxury: "יוקרה",
        luxury_desc: "סדאן, SUV, לימוזינה, סופר קאר — עם או בלי נהג.",
        crane: "הובלת מנוף",
        crane_desc: "‏12–42‏ מ׳ ומעלה — מנופים ניידים לכל עבודה.",
        limousine: "לימוזינה",
        delivery_desc: "חבילות, אוכל וקניות באותו יום.",
      },
      landing: {
        requestCtaPlaceholder: "היכן אתה זקוק לעזרה?",
        requestOne: "הזמן שירות",
        servicesTitle: "שירותים",
        hello: "שלום",
        helloBack: "ברוך שובך",
        searchPlaceholder: "חפש שירות, מונית, מוסכניק…",
        popular: "פופולריים",
        popularBadge: "פופולרי",
        popularSub: "המבוקשים ביותר בסביבתך",
        walletTitle: "שלם וקדימה",
        freeSignup: "הרשמה חינם — משלמים רק בהזמנה",
        bannerEyebrow: "מבצע",
        bannerTitle: "הזמינו מהר. חסכו יותר.",
        bannerSubtitle: "מזומן או כרטיס · 15% הנחה בנסיעה ראשונה",
        explore: "גלה",
        promo1: "משלוח מהיר",
        promo2: "צוותים מאומתים",
        promo3: "המליצו והרוויחו",
        featuredEyebrow: "מפעילים מובילים",
        featuredTitle: "קרוב אליך",
        seeAll: "לכל",
        supplierEyebrow: "לנהגים",
        supplierTitleShort: "בעלים של משאיות? שמרו על הרווח.",
        supplierSub: "רישום חינם · 15% עמלה רק על עבודות שהושלמו",
        becomeSupplier: "התחל להרוויח",
        currentLocation: "המיקום שלך",
        location: "הגדר את המיקום",
        setLocation: "הקש כדי להגדיר את המיקום",
        locationDenied: "הגישה למיקום חסומה. הפעל בדפדפן כדי למצוא ספקים קרובים.",
        nearbyEyebrow: "קרוב אליך",
        nearbyTitle: "זמינים בסביבה",
        sosEyebrow: "דחוף",
        sosTitle: "פנצ'ר? צריך גרירה?",
        sosDesc: "העזרה הכי מהירה בכביש. הקש לצוות הקרוב.",
        live: "לייב",
        heroLine1: "הזמינו מובילים,",
        heroLine2: "גרירה, מוסכניקים,",
        heroLine3: "מוניות.",
        heroLine4: "משלוח אחד.",
        heroSubtitle: "שוק ישיר להובלה, מטענים, גרירה, מוניות, מוסכניק ופנצ'ריה. הרשמה חינם — משלמים במזומן או בכרטיס בהזמנה.",
        heroCtaOrder: "שלח בקשה",
        heroCtaSupplier: "לנהג איתנו",
        stats: {
          response: "זמן תגובה ממוצע",
          fee: "עלות בקשה",
          free: "חינם",
          operators: "מפעילים",
          requests: "בקשות / חודש",
        },
        catalogEyebrow: "// קטלוג שירותים",
        catalogTitle1: "שש קטגוריות.",
        catalogTitle2: "אפס מתווכים.",
        browseAll: "עיין בכל →",
        protocol: "// פרוטוקול",
        protocolTitle: "שלושה שלבים. וזהו.",
        steps: {
          s1t: "בחרו שירות",
          s1d: "עיינו בהובלה, מטענים, גרירה, מוניות, מוסכניק או פנצ'ריה. השוו לפי דירוג, מחיר ואיזור.",
          s2t: "שלחו בקשה",
          s2d: "הכניסו נקודת איסוף ופריקה, קבעו זמן והוסיפו הערות. חינם — בלי כרטיס אשראי.",
          s3t: "הספק מגיב",
          s3d: "הספק מקבל התראה מיידית — מאשר, דוחה או יוצר קשר. עקבו אחרי הסטטוס בזמן אמת.",
        },
        supplierEyebrow: "// לנהגים",
        supplierTitle1: "בעלים של משאיות?",
        supplierTitle2: "בעלים של הרווח.",
        supplierSubtitle: "הוסיפו את השירותים שלכם. קבעו מחירים. שמרו 100% מההכנסה — ללא עמלה בזמן ההשקה.",
        supplierFeat1t: "לקוחות מאומתים",
        supplierFeat1d: "בקשות אמיתיות מלקוחות שעברו בדיקה.",
        supplierFeat2t: "התראות מיידיות",
        supplierFeat2d: "בקשות חדשות מגיעות ללוח שלכם ברגע שנשלחות.",
        supplierFeat3t: "שמרו על הלקוחות",
        supplierFeat3d: "קשר ישיר, בלי עמלות ובלי מתווכים.",
        becomeSupplier: "התחל להרוויח →",
        avgRevenue: "הכנסה חודשית ממוצעת",
        perOperator: "לכל מפעיל פעיל",
      },
      auth: {
        currentPassword: "סיסמה נוכחית",
        newPassword: "סיסמה חדשה",
        confirmPassword: "אישור סיסמה חדשה",
        backToLogin: "חזרה להתחברות",
        busTier: "דרגת אוטובוס",
        changePhoto: "החלפת תמונה",
        confirmPasswordPh: "אישור סיסמה חדשה",
        craneTonnage: "יכולת מנוף (טון)",
        dailyRate: "תעריף יומי",
        devLinkLabel: "קישור פיתוח (ללא אימייל)",
        driverProfile: "פרופיל נהג",
        emailPh: "you@example.com",
        forgotDesc: "הזן את כתובת האימייל הרשומה ונשלח לך קישור חד־פעמי להגדרת סיסמה חדשה.",
        forgotHint: "בדוק בתיבת הדואר הנכנס (וגם בספאם). הקישור בתוקף ל־30 דקות.",
        forgotPassword: "שכחתי סיסמה?",
        forgotSent: "אם האימייל רשום במערכת, קישור לאיפוס נשלח.",
        forgotTitle: "שכחת את הסיסמה?",
        hourlyRate: "תעריף שעתי",
        inviteCode: "קוד הזמנה (אופציונלי)",
        luxuryHint: "כל השכרות היוקרה כוללות נהג. השאר תעריף ריק אם אינך מציע אותו.",
        luxurySpecs: "רכב יוקרה",
        newPasswordPh: "סיסמה חדשה",
        noPhoto: "אין תמונה",
        openLink: "פתח",
        paypalResumeHint: "המשך בתשלום ה־PayPal — התחבר עם",
        phone: "מספר טלפון",
        primaryService: "שירות עיקרי",
        pwMismatch: "הסיסמאות אינן תואמות",
        pwTooShort: "הסיסמה חייבת להכיל לפחות 8 תווים",
        pwUpdated: "הסיסמה עודכנה",
        resetDoneMsg: "מעביר אותך למסך ההתחברות…",
        resetNoToken: "אסימון האיפוס חסר מכתובת ה־URL",
        seatingCapacity: "מספר מושבים",
        selectService: "בחר…",
        sendResetLink: "שלח קישור לאיפוס",
        setNewDesc: "בחר סיסמה חזקה — לפחות 8 תווים.",
        setNewPassword: "הגדרת סיסמה חדשה",
        shownToCustomers: "מוצג ללקוחות",
        signInNow: "התחבר עכשיו ←",
        taxiClass: "סוג מונית",
        truckTonnage: "יכולת משאית (טון)",
        updatePassword: "עדכון סיסמה",
        uploadPhoto: "העלאת תמונה",
        vehicle: "הרכב שלך",
        signIn: "התחברות",
        signInSub: "כנס למוקד",
        signInSubDriver: "סע איתנו — התחל להרוויח.",
        signInPassenger: "כניסה כנוסע",
        signInDriver: "כניסה כנהג",
        rolePassenger: "נוסע",
        roleDriver: "נהג",
        noDriverAccount: "נהג חדש?",
        signUpDriver: "הרשמו לנהיגה",
        roleMismatchDriver: "זה חשבון נהג — נכנס כנהג.",
        roleMismatchPassenger: "זה חשבון נוסע — נכנס כנוסע.",
        createAccount: "צור חשבון",
        createSub: "הצטרף לרשת",
        email: "אימייל",
        password: "סיסמה",
        name: "שם מלא",
        noAccount: "אין לך חשבון?",
        signUp: "הירשם",
        haveAccount: "כבר יש לך חשבון?",
        iAmCustomer: "אני לקוח",
        iAmSupplier: "אני ספק",
        continueWithGoogle: "המשך עם גוגל",
        or: "או",
        welcome: "ברוך שובך",
        accountCreated: "חשבון נוצר",
        freeSignupNote: "הרשמה חינם. אין צורך בכרטיס. משלמים רק בהזמנת שירות — מזומן בהגעה או בכרטיס.",
      },
      services: {
        categorySub: "ספקים בקרבתך זמינים לעזרה",
        eyebrow: "// כל השירותים",
        title: "הצוות הכי קרוב, לפי דרישה",
        categoryEyebrow: "//",
        operatorsAvailable: "מפעילים זמינים",
        loading: "טוען מפעילים…",
        empty: "אין מפעילים בקרבתך",
        emptyDesc: "נסה להרחיב את החיפוש או קטגוריה אחרת.",
        all: "הכל",
        by: "מאת",
        per: "לכל",
        book: "בקש",
        sortedNearest: "לפי הקרוב",
      },
      booking: {
        eyebrow: "// בקשת שירות",
        title: "לאן לשלוח עזרה?",
        details: "פרטים",
        route: "מסלול",
        pickup: "איסוף",
        pickupPlaceholder: "המיקום שלך",
        dropoff: "יעד",
        dropoffPlaceholder: "לאן?",
        useMyLocation: "השתמש במיקומי",
        optional: "(אופציונלי)",
        when: "מתי",
        now: "עכשיו",
        nowDesc: "הגעה ~{{min}} דק'",
        later: "תזמן",
        laterDesc: "בחר תאריך ושעה",
        pickDateTime: "בחר תאריך ושעה",
        eta: "זמן הגעה",
        min: "דק'",
        quantity: "כמות",
        scheduled: "מועד",
        notes: "הערות",
        notesPlaceholder: "הוראות מיוחדות, מספר קומה, קוד שער…",
        summary: "סיכום בקשה",
        refPrice: "מחיר ייחוס",
        category: "קטגוריה",
        estimate: "אומדן",
        finalPrice: "המחיר הסופי מאושר ע\"י הספק",
        sendRequest: "שלח בקשה",
        freeAlert: "חינם · הספק מקבל התראה מיידית",
        requestSent: "הבקשה נשלחה — הספק קיבל התראה",
        pickupRequired: "כתובת איסוף חובה",
        onlyCustomers: "רק חשבונות לקוח יכולים לשלוח בקשות",
      },
      dashboard: {
        myRequests: "הבקשות שלי",
        supplierHq: "מרכז הספק",
        adminConsole: "קונסולת מנהל",
        totalRequests: "סה\"כ בקשות",
        active: "פעילות",
        completed: "הושלמו",
        newRequests: "בקשות חדשות",
        listings: "מודעות",
        users: "משתמשים",
        suppliers: "ספקים",
        requests: "בקשות",
        recent: "בקשות אחרונות",
        incoming: "בקשות נכנסות",
        myListings: "המודעות שלי",
        allRequests: "כל הבקשות",
        noRequests: "עדיין אין בקשות",
        noListings: "צור מודעה ראשונה →",
        browse: "עיין בשירותים →",
        newListing: "חדשה",
        newListingTitle: "מודעה חדשה",
        listingCreated: "המודעה נוצרה",
        verify: "אמת",
        markAllViewed: "סמן הכל כנקרא",
        newRequestsBanner: "בקשות חדשות",
        newRequestsBannerSub: "לקוחות מחכים לתגובה שלך.",
        accept: "אישור בקשה",
        decline: "דחייה",
        startJob: "התחל עבודה",
        markComplete: "סמן כהושלם",
        supplierLabel: "ספק",
        customerLabel: "לקוח",
        newBadge: "חדש",
        netEarnings: "רווח נקי",
        platformFees: "עמלות פלטפורמה",
        upcoming: "בקרוב",
        upcomingSection: "מתוזמן",
        scheduled: "מתוזמן",
      },
      footer: {
        privacy: "פרטיות",
        support: "תמיכה",
        terms: "תנאים",
        services: "שירותים",
        company: "החברה",
        ops: "תפעול",
        about: "אודות",
        careers: "קריירה",
        contact: "צור קשר",
        status: "סטטוס:",
        operational: "פעיל",
        dispatch: "מוקד 24/7",
        tagline: "שוק שירותים ברמה תעשייתית. ישירות מהמפעילים.",
        copyright: "© 2026 השירות המהיר — נבנה לצוות שעובד",
      },
      payment: {
        applepayHint: "תועבר ל־PayPal לאישור באמצעות Apple Pay.",
        balance: "יתרה",
        cardChip: "כרטיס",
        cardViaPaypal: "Visa · Mastercard · Amex מתקבלים — סליקה מאובטחת דרך PayPal. אין צורך בחשבון PayPal.",
        googlepayHint: "תועבר ל־PayPal לאישור באמצעות Google Pay.",
        insufficient: "לא מספיק",
        payWithWallet: "תשלום בארנק",
        topUp: "טעינה",
        wallet: "ארנק",
        method: "אמצעי תשלום",
        total: "סה\"כ",
        platformFee: "עמלת פלטפורמה",
        supplierGets: "הספק מקבל",
        feeNote: "השירות המהיר לוקח עמלה של 15% על עבודות שהושלמו. הספקים מקבלים 85% מהסכום.",
        cash: "מזומן בהגעה",
        cashDesc: "שלמו למפעיל ישירות בהגעתו.",
        card: "כרטיס · Apple Pay · Google Pay",
        cardDesc: "תשלום מאובטח — Apple Pay, Google Pay או כל כרטיס.",
        payNow: "שלם עכשיו",
        payLater: "שלח בקשה",
        confirmPayment: "מאשר תשלום…",
        paid: "שולם ואושר",
        paidDesc: "הספק קיבל הודעה. עקבו אחרי הסטטוס בלוח.",
        cancelled: "בוטל",
        cancelledDesc: "התשלום בוטל. ההזמנה לא בוצעה.",
        failed: "בעיה בתשלום",
        failedDesc: "נסה שוב או פנה לתמיכה.",
        markCashPaid: "אשר קבלת מזומן",
        cashPaid: "מזומן התקבל", walletPaid: "שולם מהארנק", walletPending: "ארנק ממתין",
        cardPaid: "שולם בכרטיס",
        awaitingCash: "בהמתנה למזומן",
        awaitingCard: "בהמתנה לתשלום",
        walletInsufficient: "יתרת הארנק אינה מספיקה לנסיעה זו.",
        receipt: {
          eyebrow: "התשלום התקבל",
          thanks: "תודה — הנהג שלך מוזמן.",
          tripSection: "הנסיעה שלך",
          pickup: "איסוף",
          dropoff: "יעד",
          breakdownSection: "פירוט תעריף",
          baseFare: "תעריף בסיס",
          distanceCharge: "מרחק",
          timeCharge: "זמן",
          surge: "תוספת ביקוש",
          total: "סה\"כ",
          txSection: "אסמכתא לעסקה",
          captureId: "מזהה עסקה",
          copy: "העתק",
          copied: "הועתק",
          captureCopied: "מזהה עסקה הועתק",
          viewOrders: "ההזמנות שלי",
          bookAnother: "הזמן שוב",
        },
        paypal: {
          signInAsOriginal: "התחבר בתור {{email}}",
          wrongUser: "התחבר כדי להשלים את התשלום",
          wrongUserDesc: "התשלום הזה התחיל מחשבון אחר:",
          wrongUserSafety: "אישור ה־PayPal שלך בטוח. שום כספים לא הועברו. התחבר עם החשבון למעלה כדי להשלים.",
          confirming: "מאשר את התשלום ב-PayPal…",
          failed: "התשלום נכשל",
          retry: "נסה שוב",
        },
      },
      request: {
        fareCalcPending: "המחיר יחושב לאחר בחירת יעד",
        base: "בסיס",
        paypalConvert: {
          charge: "חיוב PayPal",
          confirm: "להמשיך בהמרה הזאת?",
          fare: "התעריף שלך",
          rate: "שער",
          source: "מקור",
        },
        anomalyAutoFix: "תיקון יעד אוטומטי",
        anomalyCross: "הנסיעה חוצה מדינות ({{km}} ק״מ). ייתכן שאחת הכתובות שלך שגויה.",
        anomalyEyebrow: "נסיעה ארוכה — כדאי לבדוק",
        anomalyFar: "הנסיעה באורך {{km}} ק״מ — הרבה יותר ממרבית הנסיעות. אשר את שתי הכתובות.",
        anomalyFixDropoff: "תקן יעד",
        anomalyFixPickup: "תקן איסוף",
        anomalyFixed: "היעד תוקן לכתובת מקומית",
        anomalyNoFix: "לא נמצאה התאמה קרובה יותר — נסה לבחור ידנית",
        codeHint: "הנהג שלך יבקש את הקוד בן 4 הספרות לפני תחילת הנסיעה.",
        craneHours: "משך העבודה (שעות)",
        craneHoursHint: "מינימום שעתיים · שעתיים ראשונות כלולות בבסיס",
        freqDaily: "הרגל יומי",
        freqMonth: "{{n}}× החודש",
        freqTooltip: "באיזו תדירות אתה נוסע במסלול הזה",
        freqWeekly: "{{n}}× בשבוע",
        fxUnavailable: "שירות שערי החליפין אינו זמין. בחר אמצעי תשלום אחר.",
        istanbulTaxiTariffNotice: "תמחור המונית של Drivons באיסטנבול פועל לפי תעריף המונית הרשמי של איסטנבול.",
        luxuryBilling: "מודל חיוב",
        noLuxuryClasses: "סוגי רכבי יוקרה אינם זמינים במדינה זו עדיין.",
        orPickCustom: "או בחר זמן מותאם",
        paypalCurrencyUnsupported: "PayPal אינו זמין לתשלומים ב־{{cur}}. בחר אמצעי תשלום אחר.",
        pickBusClass: "בחר סוג אוטובוס",
        pinAdjusted: "האיסוף עודכן",
        pinDragHint: "גרור את הסיכה לכיוון המדויק של האיסוף",
        repeatBtn: "צא",
        repeatEyebrow: "לצאת שוב לאותה נסיעה?",
        selectOptionHint: "בחר אפשרות למטה כדי לראות את המחיר",
        shareRide: "שיתוף נסיעה",
        showThisCode: "הצג את הקוד לנהג",
        smartSuggest: "המלצה חכמה",
        suggestSwitchTo: "נסה {{cat}} לנסיעה זו ←",
        tomorrow: "מחר",
        tripVerified: "הנסיעה אומתה",
        eyebrow: "לפי דרישה",
        title: "בקשת שירות",
        serviceType: "מה אתה צריך?",
        pickup: "מיקום איסוף",
        pickupPh: "היכן אתה?",
        dropoff: "לאן?",
        dropoffPh: "יעד",
        optional: "אופציונלי",
        gps: "GPS",
        cta: "בקש עכשיו",
        note: "הנהגים הזמינים הקרובים יקבלו התראה. הראשון שיאשר יהיה הנהג שלך.",
        farePreview: "תצוגה מקדימה של המחיר",
        setPickupFirst: "הגדר איסוף כדי לראות הערכת מחיר",
        fareUnavailable: "אין תמחור זמין עבור המיקום הזה כרגע.",
        flatFare: "מחיר קבוע",
        base: "בסיס",
        addDropoffForDistance: "הוסף יעד כדי לראות הערכה לפי מרחק",
        looking: "מחפש נהג קרוב…",
        noDrivers: "עדיין אף נהג לא הגיב",
        driversAlerted: "נהגים קיבלו התראה",
        stillDeciding: "עדיין מחליטים",
        allDeclined: "כל הנהגים הקרובים סירבו או התעלמו. נסה לשלוח לנהגים נוספים או בטל ונסה שוב מאוחר יותר.",
        stillWaiting: "עדיין מחכה שנהג יאשר. אפשר להמתין, לשלוח שוב לנהגים קרובים או לבטל.",
        rebroadcast: "שלח שוב לנהגים קרובים",
        rebroadcasted: "נשלחה התראה מחדש לנהגים קרובים",
        cancel: "בטל בקשה",
        cancelled: "הבקשה בוטלה",
        driverFound: "נהג הוקצה!",
        completed: "הנסיעה הושלמה",
        viewInDashboard: "צפה בלוח הבקרה",
        locationDenied: "הרשאת מיקום נדחתה",
        locDenied: "הרשאת המיקום נדחתה. הפעל אותה בהגדרות המכשיר / הדפדפן ולחץ שוב.",
        locUnavailable: "לא הצלחנו לקבל אות GPS. נסה שוב באוויר הפתוח או הזן כתובת ידנית.",
        locTimeout: "פג הזמן לקבלת המיקום. נסה שוב.",
        locInsecure: "יש צורך בחיבור מאובטח (HTTPS) לזיהוי מיקום. אנא טען את הדף מחדש.",
        locGeneric: "לא הצלחנו לזהות את המיקום שלך. הזן את כתובת האיסוף.",
        pickCategory: "בחר קטגוריית שירות",
        needPickup: "הגדר את מיקום האיסוף",
        sent: "הבקשה נשלחה — מחפש נהג…",
        pickTaxiClass: "בחר סוג מונית",
        pickTruckBand: "קיבולת מינימלית של המשאית",
        anyCapacity: "כל אחת",
        when: "מתי צריך?",
        now: "עכשיו",
        nowHint: "שליחה מיידית",
        later: "לתזמן להמשך",
        laterHint: "הזמנה למועד עתידי",
        pickDateTime: "תאריך ושעה",
        pickWhen: "בחר תאריך ושעה",
        pickFuture: "בחר זמן שהוא לפחות 5 דקות מעכשיו",
        scheduleDispatchHint: "נתחיל לשלוח נהגים כ-10 דקות לפני מועד ההזמנה.",
        scheduled: "מתוזמן — נשלח נהג לפני מועד ההזמנה",
        ctaSchedule: "תזמן נסיעה",
        noteScheduled: "נמצא לך נהג קרוב כ-10 דקות לפני מועד ההזמנה.",
        stops: "עצירות",
        addStop: "הוספת עצירה",
        stopPh: "כתובת עצירה",
        stopsHint: "הוסף עצירות ביניים אם צריך שהנהג יעצור בדרך.",
        removeStop: "הסר עצירה",
        useMyLocation: "השתמש במיקום שלי",
        gps: "GPS",
        optional: "לא חובה",
        locationDenied: "הרשאת מיקום נדחתה",
        back: "חזרה",
        driverNearby: "נהג בקרבת מקום",
        driversNearby: "נהגים בקרבת מקום",
        arrivesIn: "מגיע בעוד",
        minShort: "דק'",
        away: "משם",
        reserve: "הזמן מראש",
        ctaChoose: "הזמן",
        driverNotes: "הערות לנהג",
        driverNotesPh: "כל מה שהנהג צריך לדעת (קוד שער, נקודת מפגש, פריטים שבירים…)",
        luxuryStyle: "סוג רכב",
        luxuryRailTitle: "רכבי יוקרה בקרבתך",
        noLuxuryNearby: "עדיין אין רכבי יוקרה זמינים באזור שלך — נסה להרחיב את אזור האיסוף או חזור בהמשך.",
        luxuryVehicle: "רכב יוקרה",
        discountCode: "קוד הנחה",
        discountPh: "הזן קוד (למשל WELCOME10)",
        discountApplied: "ההנחה הוחלה",
        newTotal: "סה\"כ חדש",
        apply: "החל",
        tireOptions: "סוג שירות פנצ'ר",
        tireSizePh: "מידת צמיג (למשל 205/55 R16)",
        tireSizeHint: "שיתוף מידת הצמיג עוזר לספק להביא את הצמיג הנכון.",
        carwashOptions: "סוג שטיפה",
        serviceOptions: {
          carwash: {
            exterior: "שטיפה חוץ",
            exterior_interior: "שטיפה חוץ + פנים",
            premium: "שטיפה פרימיום",
          },
          delivery: {
            motorcycle: "אופנוע",
            car: "רכב",
          },
          moving: {
            small_van:          "ואן קטן",
            medium_truck:       "משאית בינונית",
            large_truck:        "משאית גדולה",
            xl_truck:           "משאית כבדה",
            refrigerated_van:   "ואן קירור",
            refrigerated_truck: "משאית קירור",
          },
          moving_desc: {
            small_van:          "עד ~1 טון · 4מ״ק — פריטים קטנים, עסקים קטנים",
            medium_truck:       "עד ~3.5 טון · 15מ״ק — דירות 2-3 חדרים",
            large_truck:        "עד ~7.5 טון · 35מ״ק — דירות 4+ חדרים, מסחרי",
            xl_truck:           "12 טון+ · 60מ״ק+ — מטענים מסחריים כבדים",
            refrigerated_van:   "❄ עד ~1 טון · 4מ״ק · 2-8°C — מזון, מסעדות",
            refrigerated_truck: "❄ עד ~3.5 טון · 15מ״ק · 2-8°C — סופרים, ספקים",
          },
        },
        craneBand: "יכולת מנוף",
        luxuryMode: "עם נהג או נהיגה עצמית",
        luxuryModelPh: "דגם מועדף (למשל רולס-רויס, למבורגיני)",
        faultNote: "תיאור התקלה",
        faultNotePh: "לדוגמה: הרכב לא מתניע, נורית אזהרה, רעש חריג…",
        deliveryDetails: "פרטי כתובת המשלוח",
        apartment: "מס' דירה",
        floor: "קומה",
        building: "בניין / בלוק",
        gateCode: "קוד שער (אם יש)",
        contactPhone: "טלפון הנמען",
        leaveAtDoor: "השאר בדלת",
        leaveInLobby: "השאר בלובי",
        handToRecipient: "מסור לנמען",
      },
      luxury: {
        ladderDiscount: "הנחת השכרה ארוכה",
        newDriver: "נהג חדש",
        trips: "נסיעות",
        with_driver: "עם נהג",
        without_driver: "נהיגה עצמית",
        style_sedan: "סדאן",
        style_suv: "SUV",
        style_limousine: "לימוזינה",
        style_supercar: "סופר קאר",
        style_convertible: "קבריולה",
        per_trip: "לפי נסיעה",
        hourly: "לפי שעה",
        daily: "לפי יום",
        hr: "שעה",
        day: "יום",
        hours: "שעות",
        days: "ימים",
        chooseClass: "בחר סוג רכב",
        billing: "מודל חיוב",
        package_4h: "חבילת 4 שעות",
        package_8h: "חבילת 8 שעות",
        min: "מינימום",
        from: "החל מ־",
        expectedKm: "ק״מ צפויים (אופציונלי)",
        expectedKmPh: "ק״מ מעבר למכסה יחויבו בנוסף",
        executive_sedan: "סדאן מנהלים",
        premium_sedan: "סדאן פרימיום",
        vip_van: "ואן VIP",
        luxury_4_seats: "יוקרה · 4 מושבים",
        luxury_8_seats: "יוקרה · 8 מושבים",
      },
      fleet: {
        title: "הצי שלי",
        empty: "אין עדיין רכבים — הוסף אחד כדי לקבל קריאות",
        count_one: "רכב אחד רשום",
        count_other: "{{count}} רכבים רשומים",
        active: "פעיל",
        setActive: "הפוך לפעיל",
        addVehicle: "הוסף רכב",
        name: "כינוי",
        namePh: "לדוגמה: קאמרי כחולה",
        category: "קטגוריית שירות",
        plate: "מספר רישוי",
        color: "צבע",
        model: "דגם",
        modelPh: "לדוגמה: טויוטה קאמרי 2022",
        photo: "תמונת הרכב",
        photoHint: "הלקוחות יראו בדיוק את הרכב הזה מגיע",
        removePhoto: "הסר תמונה",
        added: "הרכב נוסף",
        removed: "הרכב הוסר",
        activated: "הרכב הפעיל עודכן",
        confirmDelete: "להסיר את הרכב הזה?",
        needLabel: "תן שם לרכב הזה",
        needCategory: "בחר קטגוריית שירות",
        addFailed: "לא ניתן להוסיף את הרכב — נסה שוב",
        activateFailed: "לא ניתן להגדיר רכב פעיל — נסה שוב",
        photoTooLarge: "התמונה גדולה מדי — בחר תמונה מתחת ל‑500KB",
        save: "הוסף לצי",
      },
      support: {
        chatEmpty: "שלח לנו הודעה — נציג צוות יענה כאן.",
        chatTitle: "צ׳אט עם התמיכה",
        escalateHint: "הבוט עונה על שאלות נפוצות. צריך נציג אנושי?",
        faqTitle: "שאלות נפוצות",
        footer: "אנחנו בדרך כלל עונים בתוך כמה שעות.",
        intro: "אנחנו כאן 24/7. צ׳אט עם הצוות שלנו למטה או שלח לנו אימייל ונחזור אליך.",
        placeholder: "הקלד את ההודעה שלך…",
        signInHint: "כדי להתחיל צ׳אט עם הצוות שלנו.",
        stateAgentOnline: "נציג מחובר",
        stateBot: "בוט",
        stateClosed: "השיחה נסגרה",
        stateWaiting: "ממתין לנציג…",
        talkToAgent: "דבר עם נציג",
        title: "תמיכה",
        subtitle: "אנחנו כאן 24/7 — צ'אט או שלח הודעה.",
        contactUs: "צור קשר",
        sendMessage: "שלח הודעה",
        typeMessage: "הקלד את הודעתך…",
        send: "שלח",
        yourMessage: "ההודעה שלך",
        replyFromUs: "מהשירות המהיר",
        ai: "AI של השירות המהיר",
        aiHint: "מענה ראשוני AI. הקלד 'נציג' כדי לדבר עם אדם.",
        waitingAgent: "ממתין לנציג שיצטרף…",
        agentJoined: "{{name}} הצטרף/ה לצ'אט",
        closed: "השיחה נסגרה. שלח הודעה חדשה כדי לפתוח מחדש.",
        translateShow: "תרגם",
        translated: "מתורגם",
        showOriginal: "הצג מקור",
      },
      rating: {
        rateService: "דרג את השירות",
        title: "איך היה?",
        subtitle: "הדירוג שלך עוזר ללקוחות אחרים לבחור את המפעילים הטובים ביותר.",
        commentPlaceholder: "אופציונלי: השאר תגובה למפעיל…",
        submit: "שלח דירוג",
        thanks: "תודה על הביקורת!",
      },
      taxi: {
        family: "משפחתי",
        standard: "רגיל",
        hybrid: "היברידי",
        family_7_seater: "משפחתי 7 מקומות",
        vip: "VIP",
        seatsShort: "מקומות",
      },
      truck: {
        up_to_1t: "עד 1 טון",
        "1_to_3_5t": "1 – 3.5 טון",
        "3_5_to_7_5t": "3.5 – 7.5 טון",
        over_7_5t: "מעל 7.5 טון",
        over_12t: "מעל 12 טון",
      },
      common: { edit: "עריכה", close: "סגור", save: "שמור" },
      language: "שפה",
    },
  },
  ru: {
    translation: {
      common: {
        pricingComingSoon: "Цены скоро появятся",
      },
      mk: {
        nav: { riders: "Пассажиры", drivers: "Водители", services: "Услуги", download: "Скачать", signin: "Войти" },
        hero: {
          eyebrow: "Доступно на 6 языках",
          h1a: "Куда угодно.", h1b: "Что угодно.",
          sub: "Поездки, доставки, переезды, помощь на дороге — Drivons связывает с проверенным исполнителем поблизости за секунды.",
          ctaGet: "Скачать приложение", ctaDrivers: "Возить с нами",
          stat1: "Языков", stat2: "Услуг", stat3: "Поддержка",
        },
        services: {
          eyebrow: "Одно приложение — все потребности",
          h2: "8 услуг в одно касание",
          sub: "От короткой поездки до поломки в пути — Drivons направит вам проверенного исполнителя за секунды.",
        },
        riders: {
          eyebrow: "Для пассажиров",
          h3: "Бронируйте за секунды. Платите как удобно.",
          p1: "Живая карта + цена заранее — без сюрпризов.", p2: "Наличные, PayPal, кошелёк или карта (через PayPal).", p3: "Живая поддержка 24/7 на вашем языке.", p4: "Оцените и оставьте чаевые прямо в чеке.",
          cta: "Попробовать Drivons бесплатно",
        },
        drivers: {
          eyebrow: "ВОДИТЕЛЯМ",
          h3: "Возите с нами. Оставляйте 85% с каждой поездки.",
          p1: "Фиксированная комиссия 15%. Никаких скрытых удержаний.", p2: "Мгновенные еженедельные выплаты через PayPal.", p3: "Свои часы — принимайте или отклоняйте любой заказ.", p4: "Заказные поездки, широкая рассылка или случайные рядом — вы выбираете.",
          cta: "Начать зарабатывать",
        },
        features: {
          eyebrow: "Почему Drivons",
          h2: "Честная цена. Реальные водители. Без сюрпризов.",
          feat1t: "Мгновенное назначение", feat1v: "Ближайший исполнитель получает уведомление менее чем за 3 секунды.",
          feat2t: "Отслеживание в реальном времени", feat2v: "Следите за водителем на карте от подачи до места назначения.",
          feat3t: "Проверенные исполнители", feat3v: "Каждый водитель лицензирован, застрахован и проверен.",
          feat4t: "6 языков", feat4v: "Английский, арабский, иврит, русский, турецкий, французский — с полным RTL.",
        },
        dl: {
          eyebrow: "Скачать Drivons",
          h2a: "Ваш город.", h2b: "В одно касание.",
          sub: "Доступно на iOS и Android. Бесплатно, без подписки.",
          note: "Ссылки на магазины появятся после одобрения. Пока — регистрация на drivon.co.il.",
          appleLine1: "Скачать из", googleLine1: "Доступно в",
        },
      },
      brand: "Drivons",
      nav: {
        services: "Услуги",
        how: "Как это работает",
        suppliers: "Для поставщиков",
        signIn: "Войти",
        getStarted: "Регистрация",
        dashboard: "Панель",
        logout: "Выйти",
        home: "Главная",
        activity: "Заявки",
        account: "Профиль",
        about: "О нас",
        pricing: "Цены",
        contact: "Контакты",
      },
      categories: {
        moving: "Переезды",
        moving_desc: "Бригады, машины, упаковка.",
        transport: "Грузоперевозки",
        transport_desc: "Дальние рейсы, LTL, рефрижератор.",
        towing: "Эвакуатор",
        towing_desc: "Круглосуточная эвакуация.",
        taxi: "Такси",
        taxi_desc: "Поездки по запросу и управление парком.",
        mechanic: "Выездной автомеханик",
        mechanic_desc: "Сертифицированные мастера с выездом.",
        tire: "Шиномонтаж",
        tire_desc: "Ремонт, замена и балансировка на месте.",
        delivery: "Доставка",
        carwash: "Мойка авто",
        bus: "Автобус",
        bus_desc: "Микроавтобус (12–15 мест) или полноразмерный автобус (30–50 мест).",
        luxury: "Люкс",
        luxury_desc: "Седан, внедорожник, лимузин, суперкар — с водителем или без.",
        crane: "Перевозка кранов",
        crane_desc: "От стрел 12–42+ м — мобильные краны на любую задачу.",
        limousine: "Лимузин",
        delivery_desc: "Курьер, еда и продукты в тот же день.",
      },
      landing: {
        hello: "Привет",
        helloBack: "С возвращением",
        searchPlaceholder: "Найти услугу, такси, механика…",
        popular: "Популярные",
        popularBadge: "Топ",
        popularSub: "самые заказываемые рядом с вами",
        walletTitle: "ПЛАТИ И ЕДЬ",
        freeSignup: "Регистрация бесплатно — оплата при заказе",
        bannerEyebrow: "АКЦИЯ",
        bannerTitle: "Заказывайте быстрее. Экономьте больше.",
        bannerSubtitle: "Наличные или карта · скидка 15% на первую поездку",
        explore: "Смотреть",
        promo1: "Быстрая отправка",
        promo2: "Проверенные бригады",
        promo3: "Приглашай и зарабатывай",
        featuredEyebrow: "ТОП ПОСТАВЩИКИ",
        featuredTitle: "Популярные рядом",
        seeAll: "Все",
        supplierEyebrow: "ВОДИТЕЛЯМ",
        supplierTitleShort: "Есть транспорт? Забирайте маржу.",
        supplierSub: "Размещение бесплатно · Комиссия 15% только с выполненных заказов",
        becomeSupplier: "Начать зарабатывать",
        currentLocation: "ВАШЕ МЕСТОПОЛОЖЕНИЕ",
        location: "УКАЖИТЕ МЕСТОПОЛОЖЕНИЕ",
        setLocation: "Нажмите, чтобы указать местоположение",
        locationDenied: "Доступ к геолокации заблокирован. Разрешите в браузере для поиска ближайших поставщиков.",
        nearbyEyebrow: "РЯДОМ С ВАМИ",
        nearbyTitle: "Доступны поблизости",
        sosEyebrow: "СРОЧНО",
        sosTitle: "Пробило колесо? Нужен эвакуатор?",
        sosDesc: "Самая быстрая помощь на дороге. Нажмите — ближайшая бригада.",
        live: "Онлайн",
        heroLine1: "Заказ грузчиков,",
        heroLine2: "эвакуатора, механиков,",
        heroLine3: "такси.",
        heroLine4: "Одна отправка.",
        heroSubtitle: "Прямой маркетплейс услуг: переезды, грузы, эвакуация, такси, выездной механик, шиномонтаж. Регистрация бесплатно — оплата наличными или картой при заказе.",
        heroCtaOrder: "Отправить заявку",
        heroCtaSupplier: "Возить с нами",
        stats: {
          response: "СРЕДНИЙ ОТКЛИК",
          fee: "СТОИМОСТЬ ЗАЯВКИ",
          free: "БЕСПЛАТНО",
          operators: "ПОСТАВЩИКИ",
          requests: "ЗАЯВОК / МЕС",
        },
        catalogEyebrow: "// КАТАЛОГ УСЛУГ",
        catalogTitle1: "Шесть категорий.",
        catalogTitle2: "Ноль посредников.",
        browseAll: "Смотреть все →",
        protocol: "// ПОРЯДОК",
        protocolTitle: "Три шага. И всё.",
        steps: {
          s1t: "ВЫБЕРИТЕ УСЛУГУ",
          s1d: "Переезды, грузы, эвакуация, такси, механик или шиномонтаж. Сравните по рейтингу, цене и району.",
          s2t: "ОТПРАВЬТЕ ЗАЯВКУ",
          s2d: "Укажите адреса, время и заметки. Бесплатно — без карты и обязательств.",
          s3t: "ПОСТАВЩИК ОТВЕЧАЕТ",
          s3d: "Поставщик получает мгновенное уведомление — принимает, отклоняет или связывается с вами.",
        },
        supplierEyebrow: "// ВОДИТЕЛЯМ",
        supplierTitle1: "Есть транспорт?",
        supplierTitle2: "Забирайте всю маржу.",
        supplierSubtitle: "Разместите услуги. Назначайте свои цены. 100% дохода ваше — на старте без комиссии.",
        supplierFeat1t: "Проверенные клиенты",
        supplierFeat1d: "Реальные заявки от проверенных пользователей.",
        supplierFeat2t: "Мгновенные уведомления",
        supplierFeat2d: "Новые заявки приходят сразу в вашу панель.",
        supplierFeat3t: "Ваши клиенты — ваши",
        supplierFeat3d: "Прямой контакт, без комиссий и лидогенерации.",
        becomeSupplier: "Начать зарабатывать →",
        avgRevenue: "Средний доход в месяц",
        perOperator: "НА АКТИВНОГО ПОСТАВЩИКА",
      },
      auth: {
        signIn: "Войти",
        signInSub: "Вход в диспетчерскую",
        signInSubDriver: "Водите с нами — начните зарабатывать.",
        signInPassenger: "Войти как пассажир",
        signInDriver: "Войти как водитель",
        rolePassenger: "Пассажир",
        roleDriver: "Водитель",
        noDriverAccount: "Новый водитель?",
        signUpDriver: "Зарегистрироваться как водитель",
        roleMismatchDriver: "Это аккаунт водителя — входим как водитель.",
        roleMismatchPassenger: "Это аккаунт пассажира — входим как пассажир.",
        createAccount: "Создать аккаунт",
        createSub: "Присоединяйтесь к сети",
        email: "Email",
        password: "Пароль",
        name: "Полное имя",
        noAccount: "Нет аккаунта?",
        signUp: "Регистрация",
        haveAccount: "Уже есть аккаунт?",
        iAmCustomer: "Я клиент",
        iAmSupplier: "Я поставщик",
        continueWithGoogle: "Войти через Google",
        or: "ИЛИ",
        welcome: "С возвращением",
        accountCreated: "Аккаунт создан",
        freeSignupNote: "Регистрация бесплатно. Без карты. Оплата только при заказе услуги — наличными или картой.",
      },
      services: {
        eyebrow: "// ВСЕ УСЛУГИ",
        title: "Ближайшая бригада по запросу",
        categoryEyebrow: "//",
        operatorsAvailable: "поставщиков доступно",
        loading: "Загрузка поставщиков…",
        empty: "Рядом никого нет",
        emptyDesc: "Расширьте поиск или выберите другую категорию.",
        all: "Все",
        by: "ОТ",
        per: "ЗА",
        book: "Заявка",
        sortedNearest: "Сначала ближайшие",
      },
      booking: {
        eyebrow: "// ЗАЯВКА",
        title: "Куда прислать помощь?",
        details: "ДЕТАЛИ",
        route: "МАРШРУТ",
        pickup: "ПОДАЧА",
        pickupPlaceholder: "Ваш текущий адрес",
        dropoff: "НАЗНАЧЕНИЕ",
        dropoffPlaceholder: "Куда?",
        useMyLocation: "МОЁ МЕСТО",
        optional: "(необ.)",
        when: "КОГДА",
        now: "Сейчас",
        nowDesc: "Прибытие ~{{min}} мин",
        later: "На потом",
        laterDesc: "Выберите дату и время",
        pickDateTime: "Дата и время",
        eta: "ПРИБЫТИЕ",
        min: "мин",
        quantity: "Количество",
        scheduled: "Время",
        notes: "Заметки",
        notesPlaceholder: "Спец. инструкции, номер этажа, код домофона…",
        summary: "ИТОГ",
        refPrice: "Ориентир. цена",
        category: "Категория",
        estimate: "Оценка",
        finalPrice: "Окончательная цена подтверждается поставщиком",
        sendRequest: "Отправить заявку",
        freeAlert: "Бесплатно · Поставщик получает уведомление сразу",
        requestSent: "Заявка отправлена — поставщик уведомлён",
        pickupRequired: "Адрес подачи обязателен",
        onlyCustomers: "Заявки могут отправлять только клиенты",
      },
      dashboard: {
        myRequests: "Мои заявки",
        supplierHq: "Кабинет поставщика",
        adminConsole: "Админ-панель",
        totalRequests: "ВСЕГО ЗАЯВОК",
        active: "АКТИВНЫЕ",
        completed: "ЗАВЕРШЕНО",
        newRequests: "НОВЫЕ ЗАЯВКИ",
        listings: "ОБЪЯВЛЕНИЯ",
        users: "ПОЛЬЗОВАТЕЛИ",
        suppliers: "ПОСТАВЩИКИ",
        requests: "ЗАЯВКИ",
        recent: "ПОСЛЕДНИЕ ЗАЯВКИ",
        incoming: "ВХОДЯЩИЕ",
        myListings: "МОИ ОБЪЯВЛЕНИЯ",
        allRequests: "ВСЕ ЗАЯВКИ",
        noRequests: "Пока нет заявок",
        noListings: "Создайте первое объявление →",
        browse: "К услугам →",
        newListing: "Новое",
        newListingTitle: "Новое объявление",
        listingCreated: "Объявление создано",
        verify: "Проверить",
        markAllViewed: "Отметить всё прочитанным",
        newRequestsBanner: "новые заявки",
        newRequestsBannerSub: "Клиенты ждут ответа.",
        accept: "Принять заявку",
        decline: "Отклонить",
        startJob: "Начать работу",
        markComplete: "Завершить",
        supplierLabel: "ПОСТАВЩИК",
        customerLabel: "КЛИЕНТ",
        newBadge: "НОВОЕ",
        netEarnings: "ЧИСТЫЙ ДОХОД",
        platformFees: "КОМИССИИ",
        upcoming: "ПРЕДСТОЯТ",
        upcomingSection: "ЗАПЛАНИРОВАНО",
        scheduled: "ПО РАСПИСАНИЮ",
      },
      footer: {
        services: "Услуги",
        company: "Компания",
        ops: "Операции",
        about: "О нас",
        careers: "Карьера",
        contact: "Контакты",
        status: "Статус:",
        operational: "РАБОТАЕТ",
        dispatch: "Диспетчер 24/7",
        tagline: "Индустриальный маркетплейс услуг. Напрямую от исполнителей.",
        copyright: "© 2026 БЫСТРЫЙ СЕРВИС — СДЕЛАНО ДЛЯ РАБОЧИХ БРИГАД",
      },
      payment: {
        method: "СПОСОБ ОПЛАТЫ",
        total: "Итого",
        platformFee: "Комиссия платформы",
        supplierGets: "Поставщик получает",
        feeNote: "Быстрый Сервис берёт 15% комиссии с выполненных заказов. Поставщик получает 85% суммы.",
        cash: "Наличные при получении",
        cashDesc: "Оплата исполнителю на месте.",
        card: "Карта · Apple Pay · Google Pay",
        cardDesc: "Безопасная оплата — Apple Pay, Google Pay или любая карта.",
        payNow: "Оплатить",
        payLater: "Отправить заявку",
        confirmPayment: "Подтверждение оплаты…",
        paid: "Оплачено",
        paidDesc: "Поставщик уведомлён. Следите за статусом в панели.",
        cancelled: "Отменено",
        cancelledDesc: "Оплата отменена. Заказ не оформлен.",
        failed: "Проблема с оплатой",
        failedDesc: "Попробуйте снова или свяжитесь с поддержкой.",
        markCashPaid: "Отметить получение наличных",
        cashPaid: "НАЛИЧНЫЕ ПОЛУЧЕНЫ", walletPaid: "ОПЛАЧЕНО КОШЕЛЬКОМ", walletPending: "КОШЕЛЁК ОЖИДАЕТ",
        cardPaid: "ОПЛАЧЕНО КАРТОЙ",
        awaitingCash: "ОЖИДАЕТ НАЛИЧНЫХ",
        awaitingCard: "ОЖИДАЕТ ОПЛАТЫ",
        walletInsufficient: "Недостаточно средств в кошельке для этой поездки.",
        receipt: {
          eyebrow: "Оплата получена",
          thanks: "Спасибо — водитель уже назначен.",
          tripSection: "Ваша поездка",
          pickup: "Подача",
          dropoff: "Пункт назначения",
          breakdownSection: "Расчёт стоимости",
          baseFare: "Базовый тариф",
          distanceCharge: "Расстояние",
          timeCharge: "Время",
          surge: "Повышенный спрос",
          total: "Итого",
          txSection: "Идентификатор платежа",
          captureId: "ID транзакции",
          copy: "Копировать",
          copied: "Скопировано",
          captureCopied: "ID транзакции скопирован",
          viewOrders: "Мои заказы",
          bookAnother: "Заказать ещё",
        },
        paypal: {
          confirming: "Подтверждаем оплату PayPal…",
          failed: "Оплата не прошла",
          retry: "Повторить",
        },
      },
      request: {
        eyebrow: "ПО ЗАПРОСУ",
        title: "Заказать услугу",
        serviceType: "Что вам нужно?",
        pickup: "Место посадки",
        pickupPh: "Где вы?",
        dropoff: "Куда?",
        dropoffPh: "Пункт назначения",
        optional: "необязательно",
        gps: "GPS",
        cta: "Заказать сейчас",
        note: "Ближайшие водители получат уведомление. Первый принявший станет вашим водителем.",
        farePreview: "Предварительная стоимость",
        setPickupFirst: "Укажите место посадки, чтобы увидеть оценку",
        fareUnavailable: "Тарифы для этого места пока недоступны.",
        flatFare: "фикс. тариф",
        base: "База",
        addDropoffForDistance: "Добавьте пункт назначения для оценки по расстоянию",
        looking: "Ищем ближайшего водителя…",
        noDrivers: "Никто пока не ответил",
        driversAlerted: "водителей уведомлено",
        stillDeciding: "ещё думают",
        allDeclined: "Все ближайшие водители отклонили или проигнорировали. Попробуйте отправить дальше или отменить.",
        stillWaiting: "Ожидаем подтверждения. Можно подождать, повторно уведомить водителей или отменить.",
        rebroadcast: "Повторно уведомить",
        rebroadcasted: "Ближайшие водители уведомлены повторно",
        cancel: "Отменить запрос",
        cancelled: "Запрос отменён",
        driverFound: "Водитель назначен!",
        completed: "Поездка завершена",
        viewInDashboard: "Открыть панель",
        locationDenied: "Доступ к геолокации отклонён",
        pickCategory: "Выберите категорию услуги",
        needPickup: "Укажите место посадки",
        sent: "Запрос отправлен — ищем водителя…",
        pickTaxiClass: "Выберите класс такси",
        pickTruckBand: "Минимальная грузоподъёмность",
        anyCapacity: "Любая",
        when: "Когда нужно?",
        now: "Сейчас",
        nowHint: "Немедленная отправка",
        later: "Запланировать",
        laterHint: "Забронировать на потом",
        pickDateTime: "Дата и время",
        pickWhen: "Выберите дату и время",
        pickFuture: "Выберите время минимум через 5 минут",
        scheduleDispatchHint: "Мы начнём поиск водителя примерно за 10 минут до времени.",
        scheduled: "Запланировано — отправим водителя ближе ко времени",
        ctaSchedule: "Запланировать поездку",
        noteScheduled: "Мы найдём водителя примерно за 10 минут до времени.",
        stops: "Остановки",
        addStop: "Добавить остановку",
        stopPh: "Адрес остановки",
        stopsHint: "Добавьте промежуточные остановки, если нужно заехать по пути.",
        removeStop: "Убрать остановку",
        useMyLocation: "Использовать моё местоположение",
        gps: "GPS",
        optional: "необязательно",
        locationDenied: "Доступ к местоположению отклонён",
        back: "Назад",
        driverNearby: "водитель рядом",
        driversNearby: "водителей рядом",
        arrivesIn: "прибудет через",
        minShort: "мин",
        away: "от вас",
        reserve: "Резерв",
        ctaChoose: "Заказать",
        driverNotes: "Комментарий водителю",
        driverNotesPh: "Всё, что нужно знать водителю (код домофона, ориентир, хрупкий груз…)",
        luxuryStyle: "Тип кузова",
        luxuryRailTitle: "Люкс-авто рядом с вами",
        noLuxuryNearby: "В вашей зоне пока нет люкс-авто — попробуйте расширить область или зайдите позже.",
        luxuryVehicle: "Люкс-авто",
        discountCode: "Промокод",
        discountPh: "Введите код (напр. WELCOME10)",
        discountApplied: "Промокод применён",
        newTotal: "Новая сумма",
        apply: "Применить",
        tireOptions: "Тип шинной услуги",
        tireSizePh: "Размер шины (напр. 205/55 R16)",
        tireSizeHint: "Укажите размер шины, чтобы мастер привёз нужную запаску.",
        carwashOptions: "Тип мойки",
        craneBand: "Грузоподъёмность крана",
        luxuryMode: "С водителем или самостоятельно",
        luxuryModelPh: "Желаемая модель (напр. Rolls-Royce, Lamborghini)",
        faultNote: "Опишите неисправность",
        faultNotePh: "Напр.: не заводится, горит лампа, странный шум…",
        deliveryDetails: "Данные адреса доставки",
        apartment: "Квартира №",
        floor: "Этаж",
        building: "Здание / корпус",
        gateCode: "Код домофона (если есть)",
        contactPhone: "Телефон получателя",
        leaveAtDoor: "Оставить у двери",
        leaveInLobby: "Оставить на ресепшн",
        handToRecipient: "Передать лично",
      },
      luxury: {
        with_driver: "С водителем",
        without_driver: "Без водителя",
        style_sedan: "Седан",
        style_suv: "Внедорожник",
        style_limousine: "Лимузин",
        style_supercar: "Суперкар",
        style_convertible: "Кабриолет",
        per_trip: "За поездку",
        hourly: "Почасовая",
        daily: "Посуточная",
        hr: "ч",
        day: "день",
        hours: "Часы",
        days: "Дни",
      },
      fleet: {
        title: "Мой автопарк",
        empty: "Пока нет машин — добавьте, чтобы получать заказы",
        count_one: "{{count}} машина в парке",
        count_few: "{{count}} машины в парке",
        count_many: "{{count}} машин в парке",
        active: "Активна",
        setActive: "Сделать активной",
        addVehicle: "Добавить машину",
        name: "Название",
        namePh: "Напр.: синий Camry",
        category: "Категория услуги",
        plate: "Номер",
        color: "Цвет",
        model: "Модель",
        modelPh: "Напр.: Toyota Camry 2022",
        photo: "Фото машины",
        photoHint: "Клиенты увидят именно эту машину при подаче",
        removePhoto: "Удалить фото",
        added: "Машина добавлена",
        removed: "Машина удалена",
        activated: "Активная машина обновлена",
        confirmDelete: "Удалить эту машину?",
        needLabel: "Дайте машине название",
        needCategory: "Выберите категорию услуги",
        addFailed: "Не удалось добавить машину — повторите",
        activateFailed: "Не удалось назначить активную машину — повторите",
        photoTooLarge: "Файл слишком большой — до 500 КБ",
        save: "Добавить в парк",
      },
      support: {
        title: "Поддержка",
        subtitle: "Мы на связи 24/7 — чат или сообщение.",
        contactUs: "Связаться",
        sendMessage: "Отправить сообщение",
        typeMessage: "Введите сообщение…",
        send: "Отправить",
        yourMessage: "Ваше сообщение",
        replyFromUs: "От Быстрого Сервиса",
        ai: "AI Быстрого Сервиса",
        aiHint: "AI отвечает первым. Напишите «оператор», чтобы позвать человека.",
        waitingAgent: "Ожидаем оператора…",
        agentJoined: "{{name}} присоединился к чату",
        closed: "Диалог закрыт. Отправьте новое сообщение, чтобы возобновить.",
        translateShow: "Перевести",
        translated: "ПЕРЕВЕДЕНО",
        showOriginal: "Показать оригинал",
      },
      rating: {
        rateService: "Оцените услугу",
        title: "Как всё прошло?",
        subtitle: "Ваш отзыв помогает другим выбрать лучших исполнителей.",
        commentPlaceholder: "Необязательный комментарий исполнителю…",
        submit: "Отправить оценку",
        thanks: "Спасибо за отзыв!",
      },
      taxi: {
        standard: "Стандарт",
        hybrid: "Гибрид",
        family_7_seater: "Семейный 7 мест",
        vip: "VIP",
        seatsShort: "мест",
      },
      truck: {
        up_to_1t: "до 1 т",
        "1_to_3_5t": "1 – 3,5 т",
        "3_5_to_7_5t": "3,5 – 7,5 т",
        over_7_5t: "свыше 7,5 т",
        over_12t: "свыше 12 т",
      },
      common: { edit: "Изм.", close: "Закрыть", save: "Сохранить" },
      language: "Язык",
    },
  },
  tr: {
    translation: {
      common: {
        pricingComingSoon: "Fiyatlandırma yakında",
      },
      mk: {
        nav: { riders: "Yolcular", drivers: "Sürücüler", services: "Hizmetler", download: "İndir", signin: "Giriş yap" },
        hero: {
          eyebrow: "6 dilde yayında",
          h1a: "Her yere.", h1b: "Her iş için.",
          sub: "Yolculuk, teslimat, taşımacılık, yolda yardım — Drivons sizi saniyeler içinde yakınınızdaki doğrulanmış operatörle buluşturur.",
          ctaGet: "Uygulamayı indir", ctaDrivers: "Bizimle sür",
          stat1: "Dil", stat2: "Hizmet", stat3: "Destek",
        },
        services: {
          eyebrow: "Tek uygulama, sonsuz ihtiyaç",
          h2: "8 hizmet, tek dokunuşta",
          sub: "Kısa bir yolculuktan yolda bir arızaya — Drivons size saniyeler içinde doğrulanmış bir operatör gönderir.",
        },
        riders: {
          eyebrow: "Yolcular için",
          h3: "Saniyeler içinde rezervasyon. Nasıl istersen öde.",
          p1: "Canlı harita + peşin ücret — sürprizsiz.", p2: "Nakit, PayPal, cüzdan veya kart (PayPal üzerinden).", p3: "7/24 insan desteği, kendi dilinde.", p4: "Sürücünü fişten değerlendir ve bahşiş bırak.",
          cta: "Drivons'u ücretsiz dene",
        },
        drivers: {
          eyebrow: "SÜRÜCÜLER İÇİN",
          h3: "Bizimle sür. Her yolculuğun %85'ini al.",
          p1: "Sabit %15 platform komisyonu. Gizli kesinti yok.", p2: "PayPal ile haftalık anında ödeme.", p3: "Saatlerini seç — her isteği kabul et veya reddet.", p4: "Rezerve yolculuklar, geniş yayın veya yakındaki rastgele — sen seçersin.",
          cta: "Kazanmaya başla",
        },
        features: {
          eyebrow: "Neden Drivons",
          h2: "Adil fiyat. Gerçek sürücüler. Sürprizsiz.",
          feat1t: "Anında görevlendirme", feat1v: "En yakın operatör 3 saniyeden kısa sürede bildirim alır.",
          feat2t: "Gerçek zamanlı takip", feat2v: "Sürücünüzü haritada baştan sona izleyin.",
          feat3t: "Doğrulanmış operatörler", feat3v: "Her sürücü ruhsatlı, sigortalı ve arka planı kontrol edilmiştir.",
          feat4t: "6 dil", feat4v: "İngilizce, Arapça, İbranice, Rusça, Türkçe, Fransızca — tam RTL desteğiyle.",
        },
        dl: {
          eyebrow: "Drivons'u edin",
          h2a: "Şehriniz.", h2b: "Tek dokunuşta.",
          sub: "iOS ve Android'de mevcut. Ücretsiz, abonelik yok.",
          note: "Mağaza linkleri uygulama onaylandığında aktif olur. O zamana kadar drivon.co.il'de kayıt olun.",
          appleLine1: "İndir", googleLine1: "Edin",
        },
      },
      brand: "Drivons",
      nav: {
        services: "Hizmetler",
        how: "Nasıl çalışır",
        suppliers: "Tedarikçiler için",
        signIn: "Giriş",
        signUp: "Kayıt ol",
        home: "Ana sayfa",
        activity: "Etkinlik",
        account: "Hesap",
        request: "Talep et",
        wallet: "Cüzdan",
      },
      landing: {
        eyebrow: "CANLI · 12.400 ekip ağda",
        heroLine1: "Yardım anında",
        heroLine2: "kapınızda.",
        heroLine3: "En yakın operatörü saniyeler içinde çağırın.",
        heroBody: "Patlak lastik mi? Boşalmış akü mi? Çekiciye, taksiye veya taşımacıya mı ihtiyacınız var? Drivons en yakın operatörü doğrudan konumunuza yönlendirir — nakit ya da kartla ödeyin.",
        ctaSend: "Talep gönder",
        ctaSell: "Hizmetini sat",
        avgResp: "Ort. yanıt",
        operators: "Operatörler",
        platformFee: "Platform ücreti",
        searchPlaceholder: "Konumunuz ile bir hizmet arayın",
        popular: "Popüler",
        popularBadge: "Popüler",
        popularSub: "yakınınızda en çok istenenler",
        requestCtaPlaceholder: "Nerede yardıma ihtiyacın var?",
        seeAll: "Tümünü gör",
        nearbyEyebrow: "Canlı",
        nearbyTitle: "Yakınınızdaki araçlar",
        requestOne: "Bir tane iste",
        // Desktop hero + shared keys (needed to prevent EN fallback)
        setLocation: "Konumu ayarla",
        live: "Canlı · Ağda 12.400 ekip",
        sosTitle: "Patlak lastik? Çekici mi gerek?",
        sosDesc: "En hızlı yol yardımı. En yakın ekibe dokun.",
        desktopH1a: "Yardım anında",
        desktopH1b: "kapınızda.",
        desktopSub: "Patlak lastik mi? Boş akü mü? Çekici, taksi veya taşımacıya mı ihtiyacın var? Drivons en yakın operatörü doğrudan konumuna yönlendirir — nakit veya kartla öde.",
        desktopFeeLabel: "PLATFORM ÜCRETİ",
        heroCtaOrder: "Talep gönder",
        heroCtaSupplier: "Bizimle sür",
        heroLine1: "Yardım,",
        heroLine2: "ihtiyacın olduğunda.",
        stats: { response: "ORT. YANIT", fee: "TALEP ÜCRETİ", free: "ÜCRETSİZ", operators: "OPERATÖRLER", requests: "AY / TALEP" },
      },
      categories: {
        moving: "Taşımacılık",
        transport: "Nakliye",
        towing: "Çekici",
        taxi: "Taksi",
        mechanic: "Yol yardımı",
        tire: "Lastik",
        delivery: "Teslimat",
        carwash: "Oto yıkama",
        bus: "Otobüs",
        bus_desc: "Kiralık minibüs veya tam otobüs.",
        luxury: "Lüks",
        luxury_desc: "Sedan, SUV, limuzin, süper araç — şoförlü ya da şoförsüz.",
        crane: "Vinç Taşımacılığı",
        crane_desc: "12–42m+ bom yükseklikleri — her kaldırma için mobil vinçler.",
        limousine: "Limuzin",
      },
      auth: {
        signIn: "Giriş",
        signInSubDriver: "Bizimle sürüş yapın — kazanmaya başlayın.",
        signInPassenger: "Yolcu olarak giriş",
        signInDriver: "Sürücü olarak giriş",
        rolePassenger: "Yolcu",
        roleDriver: "Sürücü",
        noDriverAccount: "Yeni sürücü müsünüz?",
        signUpDriver: "Sürücü olarak kaydolun",
        roleMismatchDriver: "Bu bir sürücü hesabı — sürücü olarak giriş yapılıyor.",
        roleMismatchPassenger: "Bu bir yolcu hesabı — yolcu olarak giriş yapılıyor.",
        signUp: "Kayıt ol",
        createAccount: "Hesap oluştur",
        createSub: "Aramıza katıl — kayıt ücretsiz.",
        name: "Ad Soyad",
        email: "E-posta",
        password: "Şifre",
        iAmCustomer: "Müşteriyim",
        iAmSupplier: "Tedarikçiyim",
        freeSignupNote: "Kayıt ücretsizdir. Yalnızca tamamlanan siparişlerden %15 komisyon alınır.",
        haveAccount: "Hesabınız var mı?",
        accountCreated: "Hesap oluşturuldu",
        loggedIn: "Giriş başarılı",
        continueWithGoogle: "Google ile devam et",
        driverProfile: "Sürücü profili",
        phone: "Telefon numarası",
        photo: "Profil fotoğrafı",
        shownToCustomers: "müşterilere gösterilir",
        noPhoto: "fotoğraf yok",
        uploadPhoto: "Fotoğraf yükle",
        changePhoto: "Fotoğrafı değiştir",
        photoTooLarge: "Fotoğraf çok büyük (maks 500KB)",
        vehicle: "Aracınız",
        plate: "Plaka",
        color: "Renk",
        model: "Marka ve model",
        pendingApproval: "Onay bekleniyor",
        pendingApprovalDesc: "Yönetici onayının ardından siparişleri kabul etmeye başlayabilirsiniz.",
      },
      payment: {
        method: "Ödeme yöntemi",
        cash: "Nakit",
        cashDesc: "Sürücüye nakit ödeyin",
        card: "Kart",
        cardDesc: "Apple/Google Pay dahil",
        wallet: "Cüzdan",
        payNow: "Şimdi öde",
        payLater: "Sipariş ver",
        payWithWallet: "Cüzdanla öde",
        total: "Toplam",
        platformFee: "Platform ücreti",
        supplierGets: "Sürücü alır",
        feeNote: "%15 komisyon platforma, kalan tutar doğrudan sürücüye.",
        cashPaid: "NAKİT ALINDI",
        cardPaid: "KART İLE ÖDENDİ",
        walletPaid: "CÜZDANDAN ÖDENDİ",
        awaitingCash: "NAKİT BEKLENİYOR",
        awaitingCard: "ÖDEME BEKLENİYOR",
        walletPending: "CÜZDAN BEKLİYOR",
        walletInsufficient: "Cüzdan bakiyesi bu yolculuk için yeterli değil.",
        balance: "Bakiye",
        insufficient: "yetersiz",
        topUp: "Yükleme yap",
        markCashPaid: "Nakit alındı olarak işaretle",
        confirmPayment: "Ödemeniz onaylanıyor…",
        paid: "Ödendi ve onaylandı",
        paidDesc: "Sürücüye bildirildi. Durumu panelinizden takip edin.",
        cancelled: "İptal edildi",
        cancelledDesc: "Ödeme iptal edildi. Sipariş oluşturulmadı.",
        failed: "Ödeme sorunu",
        failedDesc: "Tekrar deneyin veya destek ile iletişime geçin.",
        receipt: {
          eyebrow: "Ödeme alındı",
          thanks: "Teşekkürler — sürücünüz hazır.",
          tripSection: "Yolculuğunuz",
          pickup: "Alış",
          dropoff: "Bırakış",
          breakdownSection: "Ücret detayı",
          baseFare: "Açılış",
          distanceCharge: "Mesafe",
          timeCharge: "Süre",
          surge: "Yoğunluk",
          total: "Toplam",
          txSection: "İşlem referansı",
          captureId: "İşlem ID",
          copy: "Kopyala",
          copied: "Kopyalandı",
          captureCopied: "İşlem ID kopyalandı",
          viewOrders: "Siparişlerim",
          bookAnother: "Yeni sipariş",
        },
        paypal: {
          confirming: "PayPal ödemeniz onaylanıyor…",
          failed: "Ödeme başarısız",
          retry: "Tekrar dene",
        },
      },
      request: {
        eyebrow: "TALEP ÜZERİNE",
        title: "Hizmet talep et",
        serviceType: "Neye ihtiyacın var?",
        pickup: "Alış konumu",
        pickupPh: "Neredesin?",
        dropoff: "Nereye?",
        dropoffPh: "Varış",
        optional: "opsiyonel",
        gps: "GPS",
        cta: "Şimdi talep et",
        note: "En yakın uygun sürücüler bilgilendirilecek. İlk kabul eden senin sürücün olacak.",
        farePreview: "Ücret önizleme",
        setPickupFirst: "Ücret tahmini için alış konumunu belirt",
        fareUnavailable: "Bu konum için henüz fiyatlandırma yok.",
        flatFare: "sabit ücret",
        base: "Baz",
        addDropoffForDistance: "Mesafeye göre tahmin için varış ekle",
        looking: "Yakınlarda sürücü aranıyor…",
        noDrivers: "Henüz kimse yanıt vermedi",
        driversAlerted: "sürücü bilgilendirildi",
        stillDeciding: "hâlâ karar veriyor",
        allDeclined: "Yakınlardaki tüm sürücüler reddetti veya yanıtlamadı. Daha geniş yayın yap veya iptal et.",
        stillWaiting: "Bir sürücünün kabul etmesi bekleniyor. Bekle, tekrar yayınla veya iptal et.",
        rebroadcast: "Yakındakilere tekrar bildir",
        rebroadcasted: "Yakın sürücüler tekrar bilgilendirildi",
        cancel: "Talebi iptal et",
        cancelled: "Talep iptal edildi",
        driverFound: "Sürücü atandı!",
        completed: "Yolculuk tamamlandı",
        viewInDashboard: "Panele git",
        locationDenied: "Konum izni reddedildi",
        locDenied: "Konum izni reddedildi. Cihaz / tarayıcı ayarlarından etkinleştirip tekrar deneyin.",
        locUnavailable: "Cihaz GPS sinyali alamadı. Açık alanda tekrar deneyin veya adresi elle girin.",
        locTimeout: "Konum isteği zaman aşımına uğradı. Tekrar deneyin.",
        locInsecure: "Konum için güvenli bağlantı (HTTPS) gerekir. Lütfen sayfayı yeniden yükleyin.",
        locGeneric: "Konumunuz alınamadı. Lütfen alış adresini elle girin.",
        pickCategory: "Bir hizmet kategorisi seç",
        needPickup: "Alış konumunu belirt",
        sent: "Talep gönderildi — sürücü aranıyor…",
        pickTaxiClass: "Taksi sınıfını seçin",
        pickTruckBand: "Minimum kamyon kapasitesi",
        anyCapacity: "Herhangi",
        when: "Ne zaman lazım?",
        now: "Şimdi",
        nowHint: "Anında gönder",
        later: "Sonrası için planla",
        laterHint: "İleri bir tarih için rezerve et",
        pickDateTime: "Tarih ve saat",
        pickWhen: "Bir tarih ve saat seçin",
        pickFuture: "Şu andan en az 5 dk sonrası için seçin",
        scheduleDispatchHint: "Rezervasyondan ~10 dk önce sürücü aramaya başlarız.",
        scheduled: "Planlandı — rezervasyon saatine yakın bir sürücü göndeririz",
        ctaSchedule: "Yolculuğu Planla",
        noteScheduled: "Rezervasyondan ~10 dk önce yakın bir sürücü eşleştiririz.",
        stops: "Duraklar",
        addStop: "Durak ekle",
        stopPh: "Durak adresi",
        stopsHint: "Yol üzerinde alma/bırakma gerekiyorsa ara duraklar ekleyin.",
        removeStop: "Durağı kaldır",
        useMyLocation: "Konumumu kullan",
        gps: "GPS",
        optional: "opsiyonel",
        locationDenied: "Konum izni reddedildi",
        back: "Geri",
        driverNearby: "yakında sürücü",
        driversNearby: "yakında sürücü",
        arrivesIn: "geliş süresi",
        minShort: "dk",
        away: "uzakta",
        reserve: "Rezerve",
        ctaChoose: "İste",
        driverNotes: "Sürücü için notlar",
        driverNotesPh: "Sürücünün bilmesi gereken her şey (kapı kodu, buluşma noktası, kırılgan eşya…)",
        luxuryStyle: "Gövde tipi",
        luxuryRailTitle: "Bölgendeki lüks araçlar",
        noLuxuryNearby: "Bölgende şu an lüks araç yok — kapsama alanını genişlet ya da daha sonra tekrar bak.",
        luxuryVehicle: "Lüks araç",
        discountCode: "İndirim kodu",
        discountPh: "Kod gir (örn. WELCOME10)",
        discountApplied: "İndirim uygulandı",
        newTotal: "Yeni toplam",
        apply: "Uygula",
        tireOptions: "Lastik servisi tipi",
        tireSizePh: "Lastik ölçüsü (örn. 205/55 R16)",
        tireSizeHint: "Lastik ölçünü paylaşman, tedarikçinin doğru lastiği getirmesine yardımcı olur.",
        carwashOptions: "Yıkama tipi",
        serviceOptions: {
          carwash: {
            exterior: "Dış yıkama",
            exterior_interior: "Dış + iç yıkama",
            premium: "Premium yıkama",
          },
          delivery: {
            motorcycle: "Motosiklet",
            car: "Araba",
          },
          moving: {
            small_van:          "Küçük Van",
            medium_truck:       "Orta Kamyon",
            large_truck:        "Büyük Kamyon",
            xl_truck:           "Ağır Kamyon",
            refrigerated_van:   "Soğutmalı Van",
            refrigerated_truck: "Soğutmalı Kamyon",
          },
          moving_desc: {
            small_van:          "~1 tona kadar · 4m³ — küçük eşya, küçük işletme",
            medium_truck:       "~3.5 tona kadar · 15m³ — 2-3 odalı daire",
            large_truck:        "~7.5 tona kadar · 35m³ — 4+ odalı daire, ticari",
            xl_truck:           "12 ton+ · 60m³+ — ağır ticari kargo",
            refrigerated_van:   "❄ ~1 tona kadar · 4m³ · 2-8°C — gıda, restoran",
            refrigerated_truck: "❄ ~3.5 tona kadar · 15m³ · 2-8°C — süpermarket, tedarikçi",
          },
        },
        craneBand: "Vinç kapasitesi",
        luxuryMode: "Şoförlü veya kendin sür",
        luxuryModelPh: "Tercih ettiğin model (örn. Rolls-Royce, Lamborghini)",
        faultNote: "Arıza tanımı",
        faultNotePh: "Örn: motor çalışmıyor, uyarı ışığı, olağandışı ses…",
        deliveryDetails: "Teslimat adres detayları",
        apartment: "Daire No",
        floor: "Kat",
        building: "Bina / blok",
        gateCode: "Kapı kodu (varsa)",
        contactPhone: "Alıcının telefonu",
        leaveAtDoor: "Kapının önüne bırak",
        leaveInLobby: "Lobiye bırak",
        handToRecipient: "Alıcıya elden ver",
      },
      luxury: {
        with_driver: "Şoförlü",
        without_driver: "Şoförsüz",
        style_sedan: "Sedan",
        style_suv: "SUV",
        style_limousine: "Limuzin",
        style_supercar: "Süper araç",
        style_convertible: "Cabrio",
        per_trip: "Sefer başı",
        hourly: "Saatlik",
        daily: "Günlük",
        hr: "sa",
        day: "gün",
        hours: "Saatler",
        days: "Günler",
        chooseClass: "Sınıf seç",
        billing: "Fatura",
        package_4h: "4 saatlik paket",
        package_8h: "8 saatlik paket",
        min: "min",
        from: "başlangıç",
        expectedKm: "Beklenen km (opsiyonel)",
        expectedKmPh: "Dahil km üzerindeki mesafe ekstra ücretlendirilir",
        executive_sedan: "Yönetici Sedan",
        premium_sedan: "Premium Sedan",
        vip_van: "VIP Van",
        luxury_4_seats: "Lüks · 4 koltuk",
        luxury_8_seats: "Lüks · 8 koltuk",
      },
      fleet: {
        title: "Filom",
        empty: "Henüz araç yok — istek almak için bir araç ekle",
        count_one: "{{count}} araç kayıtlı",
        count_other: "{{count}} araç kayıtlı",
        active: "Aktif",
        setActive: "Aktif yap",
        addVehicle: "Araç ekle",
        name: "Takma ad",
        namePh: "örn. Mavi Camry",
        category: "Hizmet kategorisi",
        plate: "Plaka",
        color: "Renk",
        model: "Model",
        modelPh: "örn. Toyota Camry 2022",
        photo: "Araç fotoğrafı",
        photoHint: "Müşteriler gelen aracın aynısını görecek",
        removePhoto: "Fotoğrafı kaldır",
        added: "Araç eklendi",
        removed: "Araç kaldırıldı",
        activated: "Aktif araç güncellendi",
        confirmDelete: "Bu aracı kaldırayım mı?",
        needLabel: "Araca bir isim ver",
        needCategory: "Hizmet kategorisi seç",
        addFailed: "Araç eklenemedi — tekrar dene",
        activateFailed: "Aktif araç ayarlanamadı — tekrar dene",
        photoTooLarge: "Fotoğraf çok büyük — 500KB altı seç",
        save: "Filoya ekle",
      },
      support: {
        title: "Destek",
        subtitle: "7/24 buradayız — sohbet veya mesaj gönder.",
        contactUs: "Bize ulaş",
        sendMessage: "Mesaj gönder",
        typeMessage: "Mesajını yaz…",
        send: "Gönder",
        yourMessage: "Mesajın",
        replyFromUs: "Drivons'ten",
        ai: "Drivons AI",
        aiHint: "AI ilk yanıtlar. Bir temsilciyle konuşmak için 'temsilci' yaz.",
        waitingAgent: "Bir temsilcinin katılması bekleniyor…",
        agentJoined: "{{name}} sohbete katıldı",
        closed: "Bu konuşma kapatıldı. Yeniden açmak için yeni bir mesaj gönder.",
        translateShow: "Çevir",
        translated: "ÇEVRİLDİ",
        showOriginal: "Orijinali göster",
      },
      rating: {
        rateService: "Bu hizmeti puanla",
        title: "Nasıldı?",
        subtitle: "Puanın diğer müşterilerin en iyi operatörü seçmesine yardımcı olur.",
        commentPlaceholder: "İsteğe bağlı: operatör için bir yorum bırak…",
        submit: "Puanı gönder",
        thanks: "Değerlendirmen için teşekkürler!",
      },
      taxi: {
        standard: "Standart",
        hybrid: "Hibrit",
        family_7_seater: "Aile 7 kişilik",
        vip: "VIP",
        seatsShort: "koltuk",
      },
      truck: {
        up_to_1t: "1 t'a kadar",
        "1_to_3_5t": "1 – 3,5 t",
        "3_5_to_7_5t": "3,5 – 7,5 t",
        over_7_5t: "7,5 t üzeri",
        over_12t: "12 t üzeri",
      },
      common: { edit: "Düzenle", close: "Kapat", save: "Kaydet" },
      driver: {
        yourDriver: "Sürücünüz",
        vehicle: "Araç",
        online: "Uygun",
        offline: "Uygun değil",
        onlineDesc: "Yakındaki müşteriler aracını görebilir ve talep gönderebilir.",
        offlineDesc: "Görev dışısın. Herhangi bir dağıtım bildirimi gelmeyecek.",
        goOnline: "Çevrimiçi ol",
        goOffline: "Çevrimdışı ol",
        nowOnline: "Çevrimiçisin — yeni talepleri alıyorsun",
        nowOffline: "Çevrimdışısın — yeni talep gelmeyecek",
        shareLocation: "Konum paylaş",
        stopSharing: "Paylaşımı durdur",
        sharingLocation: "Canlı konum müşteri ile paylaşılıyor",
      },
      dashboard: {
        myRequests: "Taleplerim",
        supplierHq: "Sürücü paneli",
        adminHq: "Yönetici paneli",
        newBadge: "YENİ",
        upcoming: "Yaklaşan",
        upcomingSection: "Planlanmış siparişler",
        active: "Aktif",
        completed: "Tamamlandı",
        listings: "Hizmetlerim",
        newRequests: "Yeni talepler",
        netEarnings: "Net kazanç",
        walletCta: "Cüzdanı aç",
        quickReorder: "Hızlı tekrar sipariş",
        reorder: "Tekrar sipariş",
        reorderSuccess: "Tekrar sipariş verildi!",
        listingUnavailable: "Bu hizmet artık mevcut değil.",
        navigate: "Yol tarifi",
        accept: "Kabul et",
        decline: "Reddet",
        startJob: "İşi başlat",
        markComplete: "Tamamlandı olarak işaretle",
      },
      dispatch: {
        title: "Yakın talepler",
        subtitle: "İlk kabul eden yolculuğu alır",
        you: "sizin için",
        accept: "Kabul et",
        decline: "Reddet",
        accepted: "Yolculuk kabul edildi!",
      },
      language: "Dil",
    },
  },
  fr: {
    translation: {
      common: {
        pricingComingSoon: "Tarifs bientôt disponibles",
      },
      mk: {
        nav: { riders: "Passagers", drivers: "Chauffeurs", services: "Services", download: "Télécharger", signin: "Connexion" },
        hero: {
          eyebrow: "Disponible en 6 langues",
          h1a: "Aller partout.", h1b: "Tout faire.",
          sub: "Trajets, livraisons, déménagements, dépannage — Drivons vous connecte à un opérateur vérifié proche en quelques secondes.",
          ctaGet: "Télécharger l'app", ctaDrivers: "Conduire avec nous",
          stat1: "Langues", stat2: "Services", stat3: "Support",
        },
        services: {
          eyebrow: "Une app, tous les besoins",
          h2: "8 services, en un geste",
          sub: "D'une course rapide à une panne — Drivons vous envoie un opérateur vérifié en quelques secondes.",
        },
        riders: {
          eyebrow: "Pour les passagers",
          h3: "Réservez en secondes. Payez comme vous voulez.",
          p1: "Carte en direct + tarif à l'avance — sans surprise.", p2: "Espèces, PayPal, portefeuille ou carte (via PayPal).", p3: "Support humain 24/7, dans votre langue.", p4: "Notez et laissez un pourboire depuis le reçu.",
          cta: "Essayer Drivons gratuitement",
        },
        drivers: {
          eyebrow: "POUR CHAUFFEURS",
          h3: "Conduisez avec nous. Gardez 85 % sur chaque course.",
          p1: "Commission plate de 15 %. Aucune retenue cachée.", p2: "Versements hebdomadaires instantanés via PayPal.", p3: "Choisissez vos heures — acceptez ou refusez chaque demande.", p4: "Courses réservées, dispatch large ou aléatoire proche — vous choisissez.",
          cta: "Commencer à gagner",
        },
        features: {
          eyebrow: "Pourquoi Drivons",
          h2: "Tarifs justes. Vrais chauffeurs. Sans surprise.",
          feat1t: "Dispatch instantané", feat1v: "L'opérateur le plus proche est alerté en moins de 3 secondes.",
          feat2t: "Suivi en temps réel", feat2v: "Suivez votre chauffeur sur la carte du départ à l'arrivée.",
          feat3t: "Opérateurs vérifiés", feat3v: "Chaque chauffeur est licencié, assuré et vérifié.",
          feat4t: "6 langues", feat4v: "Anglais, arabe, hébreu, russe, turc, français — avec RTL complet.",
        },
        dl: {
          eyebrow: "Obtenir Drivons",
          h2a: "Votre ville.", h2b: "En un geste.",
          sub: "Disponible sur iOS et Android. Gratuit, sans abonnement.",
          note: "Les liens du store seront actifs après l'approbation. En attendant, inscrivez-vous sur drivon.co.il.",
          appleLine1: "Télécharger sur", googleLine1: "Disponible sur",
        },
      },
      nav: {
        home: "Accueil",
        services: "Services",
        request: "Réserver",
        activity: "Activité",
        account: "Compte",
        wallet: "Portefeuille",
        signIn: "Se connecter",
        signOut: "Se déconnecter",
        estimate: "Estimation",
        about: "À propos",
        pricing: "Tarifs",
        contact: "Contact",
      },
      landing: {
        hero: "Bougez tout, partout",
        subhero: "Taxis, déménagement, remorquage, mécanicien, livraison, lavage auto — un seul geste, un pro à la porte.",
        ctaBook: "Réserver",
        ctaEstimate: "Estimer le prix",
        ctaDrive: "Devenir chauffeur",
        setLocation: "Définir la position",
        live: "En direct",
        desktopH1a: "Bougez tout,",
        desktopH1b: "partout.",
        desktopSub: "Taxis, déménagement, remorquage, mécanicien, livraison — un professionnel à votre porte en quelques minutes.",
        desktopFeeLabel: "commission plateforme",
        heroCtaOrder: "Commander",
        heroCtaSupplier: "Devenir chauffeur",
        heroLine1: "Bougez tout,",
        heroLine2: "partout.",
        currentLocation: "Position actuelle",
        location: "Position",
        locationDenied: "Position refusée — activez-la pour de meilleurs résultats.",
        searchPlaceholder: "Que cherchez-vous ?",
        requestCtaPlaceholder: "Où avez-vous besoin d'aide ?",
        popular: "Populaire",
        popularSub: "les plus demandés près de chez vous",
        popularBadge: "Populaire",
        sosEyebrow: "Urgence",
        sosTitle: "Besoin d'aide immédiate ?",
        sosDesc: "Envoyez un signal SOS à tous les chauffeurs disponibles à proximité.",
        nearbyEyebrow: "À proximité",
        nearbyTitle: "Voitures autour de vous",
        featuredEyebrow: "En vedette",
        featuredTitle: "Services populaires",
        requestOne: "Réserver",
        stats: {
          response: "temps de réponse moyen",
          operators: "prestataires actifs",
        },
      },
      common: {
        loading: "Chargement…",
        save: "Enregistrer",
        cancel: "Annuler",
        confirm: "Confirmer",
        delete: "Supprimer",
        edit: "Modifier",
        close: "Fermer",
        back: "Retour",
        next: "Suivant",
        submit: "Envoyer",
        yes: "Oui",
        no: "Non",
        dismiss: "Ignorer",
        retry: "Réessayer",
        search: "Rechercher",
        add: "Ajouter",
        remove: "Retirer",
        continue: "Continuer",
      },
      categories: {
        moving: "Déménagement",
        transport: "Transport de marchandises",
        towing: "Dépannage",
        taxi: "Taxi",
        mechanic: "Mécanicien mobile",
        tire: "Réparation de pneu",
        delivery: "Livraison",
        carwash: "Lavage auto",
        bus: "Trajet en bus",
        crane: "Transport de grue",
        luxury: "Chauffeur de luxe",
        limousine: "Limousine",
      },
      auth: {
        signInTitle: "Content de vous revoir",
        signUpTitle: "Créer votre compte Drivons",
        email: "E-mail",
        password: "Mot de passe",
        name: "Nom complet",
        phone: "Téléphone",
        role: "Je suis…",
        customer: "Passager",
        supplier: "Chauffeur / Prestataire",
        forgotPassword: "Mot de passe oublié ?",
        rememberMe: "Se souvenir de moi",
        or: "ou",
        continueWithGoogle: "Continuer avec Google",
        alreadyHave: "Vous avez déjà un compte ?",
        noAccount: "Pas encore de compte ?",
        signInHere: "Se connecter ici",
        signUpHere: "S'inscrire ici",
        signInBtn: "Se connecter",
        signUpBtn: "Créer mon compte",
      },
      dashboard: {
        myRequests: "Mes courses",
        walletCta: "Portefeuille",
        supplierHq: "QG chauffeur",
        goOnline: "Passer en ligne",
        goOffline: "Passer hors ligne",
        available: "Disponible",
        offline: "Hors ligne",
        earnings: "Revenus",
        thisWeek: "Cette semaine",
        thisMonth: "Ce mois-ci",
        fleet: "Flotte",
        listings: "Annonces",
        requests: "Demandes",
        navigate: "Naviguer",
        switchToDriver: "Passer en mode Chauffeur",
      },
      becomeDriver: {
        cta: "Rouler avec Drivons",
        title: "Transformez votre voiture en revenus",
        subtitle: "Un seul compte, deux rôles. Réservez comme passager et gagnez comme chauffeur — pas besoin de vous réinscrire. L'admin valide sous 24h.",
        categoryLabel: "Catégorie de service",
        plateLabel: "Plaque d'immatriculation (optionnel — vous pourrez l'ajouter plus tard)",
        submit: "Débloquer le mode Chauffeur",
        success: "Vous êtes chauffeur ! L'admin vérifie votre compte sous 24h.",
      },
      payment: {
        methodCash: "Espèces",
        methodCard: "Carte",
        methodWallet: "Portefeuille",
        methodPayPal: "PayPal",
        confirmPayment: "Confirmation du paiement…",
        paid: "Payé et confirmé",
        paidDesc: "Le chauffeur a été notifié. Suivez la course depuis votre tableau de bord.",
        cancelled: "Annulé",
        cancelledDesc: "Paiement annulé. Aucune commande créée.",
        failed: "Problème de paiement",
        failedDesc: "Réessayez ou contactez le support.",
        walletInsufficient: "Le solde du portefeuille ne suffit pas pour cette course.",
        receipt: {
          eyebrow: "Paiement reçu",
          thanks: "Merci — votre chauffeur est prêt.",
          tripSection: "Votre trajet",
          pickup: "Prise en charge",
          dropoff: "Dépôt",
          breakdownSection: "Détail du prix",
          baseFare: "Prise en charge",
          distanceCharge: "Distance",
          timeCharge: "Durée",
          surge: "Forte demande",
          total: "Total",
          txSection: "Référence de transaction",
          captureId: "ID de transaction",
          copy: "Copier",
          copied: "Copié",
          captureCopied: "ID de transaction copié",
          viewOrders: "Voir mes courses",
          bookAnother: "Réserver une autre",
        },
        paypal: {
          confirming: "Confirmation de votre paiement PayPal…",
          failed: "Paiement échoué",
          retry: "Réessayer",
        },
      },
      estimate: {
        eyebrow: "Combien ça coûte ?",
        title: "Estimateur de prix de course",
        subtitle: "Choisissez votre itinéraire — nous affichons le prix exact dans votre devise locale avant que vous ne réserviez. Sans inscription.",
        pickup: "Lieu de prise en charge",
        dropoff: "Destination",
        estimate: "Estimer",
        currency: "Devise",
        estimatedPrice: "Prix estimé",
        distance: "Distance",
        duration: "Durée",
        breakdown: "Détail",
        geoTip: "Détecté depuis votre IP — sélectionne automatiquement le tarif local",
      },
      waitlist: {
        eyebrow: "Pas encore lancé chez vous",
        title: "Bientôt disponible en {{country}}",
        subtitle: "Nous grandissons vite. Laissez votre e-mail et nous vous préviendrons dès l'ouverture de Drivons en {{country}}.",
        emailPlaceholder: "votre@email.com",
        submit: "Prévenez-moi",
        joinedEyebrow: "Vous êtes sur la liste",
        socialProof: "Rejoignez {{n}} autres personnes en {{country}} qui attendent Drivons.",
      },
      currency: {
        title: "Devise",
        auto: "Auto",
        autoDesc: "Détectée depuis votre position",
      },
      driver: {
        goOnline: "Passer en ligne",
        goOffline: "Passer hors ligne",
      },
      language: "Langue",
    },
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem("haulhub_lang") || "en",
    fallbackLng: "en",
    interpolation: { escapeValue: false },
  });

export const LANGS = [
  { code: "en", label: "EN", name: "English", dir: "ltr" },
  { code: "fr", label: "FR", name: "Français", dir: "ltr" },
  { code: "ar", label: "ع", name: "العربية", dir: "rtl" },
  { code: "he", label: "עב", name: "עברית", dir: "rtl" },
  { code: "ru", label: "RU", name: "Русский", dir: "ltr" },
  { code: "tr", label: "TR", name: "Türkçe", dir: "ltr" },
];

export function applyLang(code) {
  const lng = LANGS.find((l) => l.code === code) || LANGS[0];
  i18n.changeLanguage(lng.code);
  localStorage.setItem("haulhub_lang", lng.code);
  document.documentElement.setAttribute("lang", lng.code);
  document.documentElement.setAttribute("dir", lng.dir);
}

// Apply on load
applyLang(localStorage.getItem("haulhub_lang") || "en");

export default i18n;
;
